function scbSplitPicotValue(raw){
  return String(raw || '')
    .split(',')
    .map(function(part){ return part.trim(); })
    .filter(Boolean)
    .slice(0, 2);
}

function scbSyncPicotInputs(scope, raw){
  if(!scope || !scope.querySelector) return [];
  var names = Array.isArray(raw) ? raw.filter(Boolean).slice(0, 2) : scbSplitPicotValue(raw);
  var joined = names.join(', ');
  var combined = scope.querySelector('[data-input-picot-colors]');
  var visibleCombined = scope.querySelector('[data-input-picot-colors-visible]');
  var first = scope.querySelector('[data-input-picot-color-1]');
  var second = scope.querySelector('[data-input-picot-color-2]');
  if(combined) combined.value = joined;
  if(visibleCombined) visibleCombined.value = joined;
  if(first) first.value = names[0] || '';
  if(second) second.value = names[1] || '';
  return names;
}

function scbApplyPicotProperties(props, scope, firstColorOnly){
  var raw = scope && scope.querySelector ? (scope.querySelector('[data-input-picot-colors]') || {}).value : '';
  var names = scbSplitPicotValue(raw);
  if(!names.length && scope && scope.querySelectorAll){
    names = Array.prototype.slice.call(scope.querySelectorAll('[data-color-kind="picot"].is-active'))
      .map(function(btn){ return btn.getAttribute('data-color-name') || ''; })
      .filter(Boolean)
      .slice(0, 2);
  }
  names = scbSyncPicotInputs(scope, names);
  if(firstColorOnly) names = names.slice(0, 1);
  delete props["Picot Elastic Color 1"];
  delete props["Picot Elastic Color 2"];
  if(names.length) props["Picot Elastic Colors"] = names.join(', ');
  else delete props["Picot Elastic Colors"];
  if(names[0]) props["Picot Elastic Color 1"] = names[0];
  if(names[1]) props["Picot Elastic Color 2"] = names[1];
  return props;
}

(function(){
function closestZone(el, root){ while(el && el!==document && el!==root){ if(el.classList && el.classList.contains('scb-zone-group')) return el; el=el.parentNode; } return el && el.classList && el.classList.contains('scb-zone-group') ? el : null; }
var summaryPriority={'Main Fabric':1,'Side Inlay':2,'Inner Accent':3,'Center Inlay':4,'Binding & Straps':5};
function normalizedZoneLabel(label){ return String(label||'').replace(/^(Top|Bottom)\s+/, ''); }
function sortZonesForSummary(list){ return list.slice().sort(function(a,b){ var la=normalizedZoneLabel(a.getAttribute('data-zone-label')||''); var lb=normalizedZoneLabel(b.getAttribute('data-zone-label')||''); return (summaryPriority[la]||50)-(summaryPriority[lb]||50); }); }
function init(root){ if(!root || root.dataset.scbInitialized==='true') return; root.dataset.scbInitialized='true';
var swatches=[].slice.call(root.querySelectorAll('.scb-swatch'));
var zones=[].slice.call(root.querySelectorAll('.scb-zone-group'));
var styleBtns=[].slice.call(root.querySelectorAll('.scb-style-card'));
var modeBtns=[].slice.call(root.querySelectorAll('.scb-mode-btn'));
var activeZoneLabel=root.querySelector('[data-active-zone-label]');
var activeSwatchLabel=root.querySelector('[data-active-swatch-label]');
var designJsonInput=root.querySelector('[data-design-json]');
var zoneList=root.querySelector('[data-zone-list]');
var form=root.querySelector('[data-scb-cart-form]');
var stage=root.querySelector('[data-stage]');
var styleDrawer=root.querySelector('[data-style-drawer]');
var styleTitle=root.querySelector('[data-style-title]');
var styleSummary=root.querySelector('[data-style-summary]');
var colorButtons=[].slice.call(root.querySelectorAll('[data-color-kind]'));
var bowColorInput=root.querySelector('[data-input-bow-color]');
var trimColorInput=root.querySelector('[data-input-trim-color]');
var stylePickState={top:false,bottom:false};
var activeSwatch=swatches[0];
var activeZone=null; var ignoreNextClick=false; var mode='set';
var activeStyles={ top:(root.querySelector('.scb-style-card[data-style-kind="top"].is-active')||{}).dataset?.styleId || '', bottom:(root.querySelector('.scb-style-card[data-style-kind="bottom"].is-active')||{}).dataset?.styleId || ''};
var activeStyleNames={ top:(root.querySelector('.scb-style-card[data-style-kind="top"].is-active')||{}).dataset?.styleName || '', bottom:(root.querySelector('.scb-style-card[data-style-kind="bottom"].is-active')||{}).dataset?.styleName || ''};
var state={};
var detailState={bowColor:'Charcoal', trimColor:'Black'};
var initializing=true;
function modeLabel(){ return mode==='set' ? 'Top + Bottom Set' : (mode==='top' ? 'Top only' : 'Bottom only'); }
function styleStepForMode(){ return mode==='bottom' ? 'bottom' : 'top'; }
function updateStyleDrawerTitle(){ if(styleTitle) styleTitle.textContent = styleDrawer && styleDrawer.open ? 'Select Style' : 'Style Selected'; }
function updateStyleSummary(){
  if(!styleSummary) return;
  var parts=[modeLabel()];
  if(mode !== 'bottom' && activeStyleNames.top) parts.push(activeStyleNames.top);
  if(mode !== 'top' && activeStyleNames.bottom) parts.push(activeStyleNames.bottom);
  styleSummary.textContent=parts.join(' · ');
  updateStyleDrawerTitle();
}
function visibleTemplates(){ return [].slice.call(root.querySelectorAll('.scb-template-svg.is-visible')).filter(function(svg){ var k=svg.getAttribute('data-style-kind'); return mode==='set' || mode===k;}); }
function visibleZones(){ var out=[]; visibleTemplates().forEach(function(svg){ out=out.concat([].slice.call(svg.querySelectorAll('.scb-zone-group')));}); return out; }
function setActiveSwatch(swatch){ if(!swatch) return; activeSwatch=swatch; swatches.forEach(function(el){ el.classList.toggle('is-active', el===swatch);}); if(activeSwatchLabel) activeSwatchLabel.textContent=swatch.getAttribute('data-swatch-name')||''; }
function setActiveZone(zone){ if(!zone) return; activeZone=zone; zones.forEach(function(el){ el.classList.toggle('is-active', el===zone);}); if(activeZoneLabel) activeZoneLabel.textContent=zone.getAttribute('data-zone-label')||''; }
function applyFill(zone, swatch){ if(!zone || !swatch) return; var swatchId=swatch.getAttribute('data-swatch-id'); var templateId=zone.getAttribute('data-template-id'); var zoneId=zone.getAttribute('data-zone-id'); var swatchName=swatch.getAttribute('data-swatch-name')||''; if(!swatchId||!zoneId||!templateId) return; var patternId='scb-pattern-' + templateId + '-' + swatchId; [].slice.call(zone.querySelectorAll('path')).forEach(function(path){ path.setAttribute('fill','url(#'+patternId+')'); path.style.fill='url(#'+patternId+')'; path.style.stroke='rgba(5,5,5,.99)'; path.style.strokeWidth='4.8px'; path.style.paintOrder='fill stroke'; path.style.vectorEffect='non-scaling-stroke'; path.style.strokeLinejoin='round'; path.style.strokeLinecap='round'; path.style.strokeMiterlimit='2'; }); state[zoneId]={ label:zone.getAttribute('data-zone-label')||zoneId, swatchId:swatchId, swatchName:swatchName, patternId:patternId, templateId:templateId}; updateSummary(); }
function updateSummary(){ if(zoneList){ zoneList.innerHTML=''; sortZonesForSummary(visibleZones()).forEach(function(zone){ var id=zone.getAttribute('data-zone-id'); var item=state[id]; var li=document.createElement('li'); var label=document.createElement('span'); var value=document.createElement('strong'); label.textContent=zone.getAttribute('data-zone-label')||id; value.textContent=item ? item.swatchName : (activeSwatch ? activeSwatch.getAttribute('data-swatch-name') : 'Not selected'); li.appendChild(label); li.appendChild(value); zoneList.appendChild(li);}); }
 var modeInput=root.querySelector('[data-input-mode]'); var topInput=root.querySelector('[data-input-top-style]'); var bottomInput=root.querySelector('[data-input-bottom-style]'); if(modeInput) modeInput.value=mode==='set' ? 'Top + Bottom Set' : (mode==='top' ? 'Top only' : 'Bottom only'); if(topInput) topInput.value=activeStyleNames.top||''; if(bottomInput) bottomInput.value=activeStyleNames.bottom||''; if(designJsonInput) designJsonInput.value=JSON.stringify({ purchaseMode:mode, topStyle:activeStyleNames.top, bottomStyle:activeStyleNames.bottom, zones:state, details:detailState }); }
function setMode(nextMode){ mode=nextMode; if(stage) stage.setAttribute('data-mode', mode); modeBtns.forEach(function(btn){ btn.classList.toggle('is-active', btn.getAttribute('data-mode')===mode); }); var topGroup=root.querySelector('[data-style-group="top"]'); var bottomGroup=root.querySelector('[data-style-group="bottom"]'); if(topGroup) topGroup.style.display = mode==='bottom' ? 'none' : ''; if(bottomGroup) bottomGroup.style.display = mode==='top' ? 'none' : ''; var first=sortZonesForSummary(visibleZones())[0]; if(first) setActiveZone(first); stylePickState.top=false; stylePickState.bottom=false; if(styleDrawer){ styleDrawer.setAttribute('data-step-needed', styleStepForMode()); if(!initializing) styleDrawer.setAttribute('open','open'); updateStyleDrawerTitle(); } updateStyleSummary(); updateSummary(); }
function setStyle(kind, styleId, styleName){ activeStyles[kind]=styleId; activeStyleNames[kind]=styleName||styleId; styleBtns.forEach(function(btn){ if(btn.getAttribute('data-style-kind')===kind){ btn.classList.toggle('is-active', btn.getAttribute('data-style-id')===styleId); }}); [].slice.call(root.querySelectorAll('.scb-template-svg[data-style-kind="'+kind+'"]')).forEach(function(svg){ svg.classList.toggle('is-visible', svg.getAttribute('data-style-id')===styleId); }); var currentVisible=visibleZones(); currentVisible.forEach(function(zone){ if(!state[zone.getAttribute('data-zone-id')]) applyFill(zone, activeSwatch); }); var first=sortZonesForSummary(currentVisible)[0]; if(first) setActiveZone(first); updateStyleSummary();
 if(styleDrawer && !initializing){
   stylePickState[kind]=true;
   if(mode==='set' && kind==='top'){
     styleDrawer.setAttribute('open','open');
     styleDrawer.setAttribute('data-step-needed','bottom');
   } else {
     styleDrawer.removeAttribute('open');
     styleDrawer.removeAttribute('data-step-needed');
     stylePickState.top=false; stylePickState.bottom=false;
   }
   updateStyleDrawerTitle();
 }
 updateSummary(); }
function makeGhost(swatch){ var ghost=swatch.cloneNode(true); ghost.className='scb-drag-ghost'; ghost.removeAttribute('draggable'); document.body.appendChild(ghost); return ghost; }
function moveGhost(ghost,x,y){ if(!ghost) return; ghost.style.left=x+'px'; ghost.style.top=y+'px'; }
function startPointerDrag(event, swatch){ if(event.pointerType==='mouse' && event.button!==0) return; setActiveSwatch(swatch); var drag={swatch:swatch,startX:event.clientX,startY:event.clientY,dragging:false,ghost:null}; function onMove(e){ var dx=Math.abs(e.clientX-drag.startX), dy=Math.abs(e.clientY-drag.startY); if(!drag.dragging && (dx>6 || dy>6)){ drag.dragging=true; drag.ghost=makeGhost(swatch); root.classList.add('scb-is-dragging'); } if(drag.dragging){ e.preventDefault(); moveGhost(drag.ghost,e.clientX,e.clientY); var target=document.elementFromPoint(e.clientX,e.clientY); var zone=closestZone(target,root); zones.forEach(function(z){ z.classList.toggle('is-drop-target', z===zone);}); }} function onUp(e){ document.removeEventListener('pointermove',onMove,true); document.removeEventListener('pointerup',onUp,true); zones.forEach(function(z){ z.classList.remove('is-drop-target');}); root.classList.remove('scb-is-dragging'); if(drag.dragging){ e.preventDefault(); ignoreNextClick=true; var target=document.elementFromPoint(e.clientX,e.clientY); var zone=closestZone(target,root); if(zone){ setActiveZone(zone); applyFill(zone,drag.swatch);} if(drag.ghost && drag.ghost.parentNode) drag.ghost.parentNode.removeChild(drag.ghost); setTimeout(function(){ ignoreNextClick=false;},0);} }
 document.addEventListener('pointermove',onMove,true); document.addEventListener('pointerup',onUp,true); }
 swatches.forEach(function(swatch){ swatch.addEventListener('click',function(){ if(ignoreNextClick) return; setActiveSwatch(swatch);}); swatch.addEventListener('dragstart', function(event){ setActiveSwatch(swatch); if(event.dataTransfer){ event.dataTransfer.setData('text/plain', swatch.getAttribute('data-swatch-id')||''); event.dataTransfer.effectAllowed='copy'; }}); swatch.addEventListener('pointerdown', function(event){ startPointerDrag(event, swatch);}); });
 zones.forEach(function(zone){ zone.addEventListener('click', function(){ setActiveZone(zone); applyFill(zone, activeSwatch);}); zone.addEventListener('dragenter', function(event){ event.preventDefault(); zone.classList.add('is-drop-target');}); zone.addEventListener('dragover', function(event){ event.preventDefault(); if(event.dataTransfer) event.dataTransfer.dropEffect='copy'; zone.classList.add('is-drop-target');}); zone.addEventListener('dragleave', function(){ zone.classList.remove('is-drop-target');}); zone.addEventListener('drop', function(event){ event.preventDefault(); zone.classList.remove('is-drop-target'); var sid=event.dataTransfer ? event.dataTransfer.getData('text/plain') : ''; var swatch=swatches.filter(function(x){ return x.getAttribute('data-swatch-id')===sid;})[0] || activeSwatch; setActiveSwatch(swatch); setActiveZone(zone); applyFill(zone, swatch);}); });
 styleBtns.forEach(function(btn){ btn.addEventListener('click', function(){ setStyle(btn.getAttribute('data-style-kind'), btn.getAttribute('data-style-id'), btn.getAttribute('data-style-name')); }); });
 modeBtns.forEach(function(btn){ btn.addEventListener('click', function(){ setMode(btn.getAttribute('data-mode')); }); });
 if(styleDrawer){ styleDrawer.addEventListener('toggle', function(){ if(styleDrawer.open && !styleDrawer.getAttribute('data-step-needed')) styleDrawer.setAttribute('data-step-needed', styleStepForMode()); updateStyleDrawerTitle(); }); }
 
colorButtons.forEach(function(btn){
  btn.addEventListener('click', function(){
    var kind=btn.getAttribute('data-color-kind');
    var name=btn.getAttribute('data-color-name') || '';
    var value=btn.getAttribute('data-color-value') || '#111111';
    colorButtons.forEach(function(other){
      if(other.getAttribute('data-color-kind')===kind) other.classList.toggle('is-active', other===btn);
    });
    if(kind==='bow'){
      detailState.bowColor=name;
      root.style.setProperty('--scb-bow-color', value);
      if(bowColorInput) bowColorInput.value=name;
    }
    if(kind==='trim'){
      detailState.trimColor=name;
      root.style.setProperty('--scb-trim-color', value);
      if(trimColorInput) trimColorInput.value=name;
    }
    updateSummary();
  });
});
root.style.setProperty('--scb-bow-color', '#111111');
root.style.setProperty('--scb-trim-color', '#111111');

if(form){ form.addEventListener('submit', function(event){ var idInput=form.querySelector('input[name="id"]'); if(!idInput || !idInput.value){ event.preventDefault(); alert('Missing variant ID in section settings.'); }}); }
 setActiveSwatch(swatches[0]); setStyle('top', activeStyles.top, activeStyleNames.top); setStyle('bottom', activeStyles.bottom, activeStyleNames.bottom); setMode('set'); initializing=false; if(styleDrawer){ styleDrawer.setAttribute('open','open'); styleDrawer.setAttribute('data-step-needed','top'); updateStyleDrawerTitle(); } updateStyleSummary(); visibleZones().forEach(function(zone){ applyFill(zone, swatches[0]); }); var first=sortZonesForSummary(visibleZones())[0]; if(first) setActiveZone(first); updateSummary();
}
function initAll(){ [].slice.call(document.querySelectorAll('[data-scb-customizer]')).forEach(init); }
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initAll);} else { initAll(); }
document.addEventListener('shopify:section:load', function(event){ var root=event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null; if(root) init(root); });
})();


/* v17 final option-flow controller */
(function(){
  function initV17(root){
    if(!root || root.dataset.scbV17Initialized === 'true') return;
    root.dataset.scbV17Initialized = 'true';

    var detail = {
      bowColor:'Charcoal',
      picotColors:[],
      sequins:'No',
      sequinColor:'',
      lace:'Yes',
      laceColor:'Black',
      strap:'Knot'
    };

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function setStep(name, open){
      var el=q('[data-step-section="'+name+'"]');
      if(el) el.classList.toggle('is-collapsed', !open);
    }
    function openStep(name){
      ['fabric','bow','picot','sequins','lace','strap'].forEach(function(step){ setStep(step, step===name); });
    }
    function setText(sel, text){ var el=q(sel); if(el) el.textContent=text; }
    function sync(){
      var input;
      setText('[data-bow-summary]', detail.bowColor);
      setText('[data-picot-summary]', detail.picotColors.length ? detail.picotColors.join(', ') : 'Choose 1 or 2');
      setText('[data-sequin-summary]', detail.sequins === 'Yes' ? ('Yes' + (detail.sequinColor ? ' · ' + detail.sequinColor : '')) : 'No');
      setText('[data-lace-summary]', 'Black');
      setText('[data-strap-summary]', detail.strap);

      input=q('[data-input-bow-color]'); if(input) input.value=detail.bowColor;
      scbSyncPicotInputs(root, detail.picotColors);
      input=q('[data-input-sequins]'); if(input) input.value=detail.sequins;
      input=q('[data-input-sequin-color]'); if(input) input.value=detail.sequinColor;
      input=q('[data-input-lace]'); if(input) input.value=detail.lace;
      input=q('[data-input-lace-color]'); if(input) input.value=detail.laceColor;
      input=q('[data-input-strap]'); if(input) input.value=detail.strap;

      var colors = {'Dusty Rose':'#B78792','Charcoal':'#111111','Mocha':'#7B6A58','Moss':'#61735A','Baby Blue':'#A9C9DF'};
      root.style.setProperty('--scb-bow-color', colors[detail.bowColor] || '#B78792');
    }

    qa('[data-toggle-step]').forEach(function(btn){
      btn.addEventListener('click', function(){ openStep(btn.getAttribute('data-toggle-step')); });
    });

    qa('[data-complete-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step=btn.getAttribute('data-complete-step');
        if(step==='fabric') openStep('bow');
        else if(step==='bow') openStep('picot');
        else if(step==='picot') openStep('sequins');
        else if(step==='sequins') openStep('lace');
        else if(step==='lace') openStep('strap');
        else setStep(step, false);
      });
    });

    qa('[data-color-kind]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var kind=btn.getAttribute('data-color-kind');
        var name=btn.getAttribute('data-color-name') || '';
        if(kind==='picot'){
          var active=btn.classList.contains('is-active');
          if(active){
            btn.classList.remove('is-active');
            detail.picotColors=detail.picotColors.filter(function(x){ return x!==name; });
          } else {
            if(detail.picotColors.length >= 2) return;
            btn.classList.add('is-active');
            detail.picotColors.push(name);
          }
        } else {
          qa('[data-color-kind="'+kind+'"]').forEach(function(other){ other.classList.toggle('is-active', other===btn); });
          if(kind==='bow') detail.bowColor=name;
          if(kind==='sequins') detail.sequinColor=name;
        }
        sync();
      });
    });

    qa('[data-choice-kind]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var kind=btn.getAttribute('data-choice-kind');
        var val=btn.getAttribute('data-choice-value');
        qa('[data-choice-kind="'+kind+'"]').forEach(function(other){ other.classList.toggle('is-active', other===btn); });
        if(kind==='sequins'){
          detail.sequins=val;
          var dep=q('[data-dependent="sequins"]');
          if(dep) dep.hidden = val !== 'Yes';
          if(val==='Yes' && !detail.sequinColor) detail.sequinColor='Rose Gold';
          if(val==='No') detail.sequinColor='';
        }
        if(kind==='lace') detail.lace=val;
        if(kind==='strap') detail.strap=val;
        sync();
      });
    });

    setStep('fabric', true);
    ['bow','picot','sequins','lace','strap'].forEach(function(s){ setStep(s, false); });
    sync();
  }
  function initAll(){ Array.prototype.slice.call(document.querySelectorAll('[data-scb-customizer]')).forEach(initV17); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(event){
    var root=event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV17(root);
  });
})();


/* v19 active-style attributes for conditional bows */
(function(){
  function initV19(root){
    if(!root || root.dataset.scbV19Initialized === 'true') return;
    root.dataset.scbV19Initialized = 'true';
    var stage = root.querySelector('[data-stage]');
    function setActiveAttrs(){
      if(!stage) return;
      var top = root.querySelector('.scb-style-card[data-style-kind="top"].is-active');
      var bottom = root.querySelector('.scb-style-card[data-style-kind="bottom"].is-active');
      var mode = root.querySelector('.scb-mode-btn.is-active');
      if(top) stage.setAttribute('data-active-top', top.getAttribute('data-style-id') || '');
      if(bottom) stage.setAttribute('data-active-bottom', bottom.getAttribute('data-style-id') || '');
      if(mode) stage.setAttribute('data-mode', mode.getAttribute('data-mode') || 'set');
    }
    root.querySelectorAll('.scb-style-card, .scb-mode-btn').forEach(function(btn){
      btn.addEventListener('click', function(){ setTimeout(setActiveAttrs, 0); });
    });
    setActiveAttrs();
  }
  function initAllV19(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV19);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV19);
  else initAllV19();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV19(root);
  });
})();


/* v20 fixes: fabric collapse works; no bow overlay behavior. */
(function(){
  function initV20(root){
    if(!root || root.dataset.scbV20Initialized === 'true') return;
    root.dataset.scbV20Initialized = 'true';

    var fabricDone = root.querySelector('.scb-fabric-done, [data-complete-step="fabric"]');
    var fabricGrid = root.querySelector('.scb-swatch-grid');
    var fabricHead = root.querySelector('.scb-fabric-head') || root.querySelector('.scb-panel-head + .scb-swatch-grid')?.previousElementSibling;
    var bowSection = root.querySelector('[data-step-section="bow"]');

    function collapseFabrics(){
      root.classList.add('scb-fabric-collapsed');
      if(fabricGrid) fabricGrid.style.display = 'none';
      if(fabricDone) fabricDone.style.display = 'none';
      if(fabricHead && !fabricHead.querySelector('[data-reopen-fabrics]')){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'scb-step-toggle scb-fabric-reopen';
        btn.setAttribute('data-reopen-fabrics', '');
        btn.textContent = 'Change';
        btn.addEventListener('click', reopenFabrics);
        fabricHead.appendChild(btn);
      }
      if(bowSection) bowSection.classList.remove('is-collapsed');
    }

    function reopenFabrics(){
      root.classList.remove('scb-fabric-collapsed');
      if(fabricGrid) fabricGrid.style.display = '';
      if(fabricDone) fabricDone.style.display = '';
      var btn = fabricHead && fabricHead.querySelector('[data-reopen-fabrics]');
      if(btn) btn.remove();
    }

    if(fabricDone){
      fabricDone.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        collapseFabrics();
      }, true);
    }

    // Make sure old overlay cannot show even if markup survived.
    root.querySelectorAll('.scb-bow-layer, .scb-bow').forEach(function(el){
      el.style.display = 'none';
    });
  }

  function initAllV20(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV20);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV20);
  else initAllV20();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV20(root);
  });
})();


/* v21: picot multi-select + visual tint fixes. */
(function(){
  function initV21(root){
    if(!root || root.dataset.scbV21Initialized === 'true') return;
    root.dataset.scbV21Initialized = 'true';

    var state = { bowColor:'Charcoal', picotColors:[], lace:'Yes', sequins:'No', sequinColor:'', strap:'Knot' };
    var bowColors = {'Dusty Rose':'#B78792','Charcoal':'#111111','Mocha':'#7B6A58','Moss':'#61735A','Baby Blue':'#A9C9DF'};
    var picotColors = {'Soft Pink':'#DBC8C8','Shimmery Black':'#191919','Moss Green':'#61735A','Matte Black':'#050505'};
    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function txt(sel, value){ var el=q(sel); if(el) el.textContent=value; }
    function sync(){
      txt('[data-bow-summary]', state.bowColor);
      txt('[data-picot-summary]', state.picotColors.length ? state.picotColors.join(', ') : 'Choose 1 or 2');
      txt('[data-lace-summary]', 'Black');
      txt('[data-sequin-summary]', state.sequins === 'Yes' ? ('Yes' + (state.sequinColor ? ' · ' + state.sequinColor : '')) : 'No');
      txt('[data-strap-summary]', state.strap);
      root.style.setProperty('--scb-bow-ui-color', bowColors[state.bowColor] || '#B78792');
      root.style.setProperty('--scb-picot-ui-color', state.picotColors.length ? (picotColors[state.picotColors[0]] || '#111111') : '#111111');
      var input;
      input=q('[data-input-bow-color]'); if(input) input.value=state.bowColor;
      scbSyncPicotInputs(root, state.picotColors);
      input=q('[data-input-lace]'); if(input) input.value=state.lace;
      input=q('[data-input-lace-color]'); if(input) input.value='Black';
      input=q('[data-input-sequins]'); if(input) input.value=state.sequins;
      input=q('[data-input-sequin-color]'); if(input) input.value=state.sequinColor;
      input=q('[data-input-strap]'); if(input) input.value=state.strap;
    }
    qa('[data-color-kind="bow"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        qa('[data-color-kind="bow"]').forEach(function(x){ x.classList.toggle('is-active', x===btn); });
        state.bowColor=btn.getAttribute('data-color-name') || 'Dusty Rose';
        sync();
      }, true);
    });
    qa('[data-color-kind="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var name=btn.getAttribute('data-color-name') || '';
        if(btn.classList.contains('is-active')){
          btn.classList.remove('is-active');
          state.picotColors=state.picotColors.filter(function(x){ return x!==name; });
        } else {
          if(state.picotColors.length >= 2) return;
          btn.classList.add('is-active');
          state.picotColors.push(name);
        }
        sync();
      }, true);
    });
    qa('[data-choice-kind="sequins"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        qa('[data-choice-kind="sequins"]').forEach(function(x){ x.classList.toggle('is-active', x===btn); });
        state.sequins=btn.getAttribute('data-choice-value') || 'No';
        var dep=q('[data-dependent="sequins"]');
        if(dep) dep.hidden = state.sequins !== 'Yes';
        if(state.sequins==='No') state.sequinColor='';
        if(state.sequins==='Yes' && !state.sequinColor) state.sequinColor='Rose Gold';
        sync();
      }, true);
    });
    qa('[data-color-kind="sequins"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        qa('[data-color-kind="sequins"]').forEach(function(x){ x.classList.toggle('is-active', x===btn); });
        state.sequinColor=btn.getAttribute('data-color-name') || '';
        sync();
      }, true);
    });
    qa('[data-choice-kind="strap"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        qa('[data-choice-kind="strap"]').forEach(function(x){ x.classList.toggle('is-active', x===btn); });
        state.strap=btn.getAttribute('data-choice-value') || 'Knot';
        sync();
      }, true);
    });
    qa('.scb-step-toggle, .scb-style-drawer summary b').forEach(function(btn){
      if(btn.textContent.trim().toLowerCase()==='change') btn.textContent='Change';
    });
    sync();
  }
  function initAllV21(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV21); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAllV21);
  else initAllV21();
  document.addEventListener('shopify:section:load', function(event){
    var root=event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV21(root);
  });
})();


/* v22 wording/formatting fixes */
(function(){
  function initV22(root){
    if(!root || root.dataset.scbV22Initialized === 'true') return;
    root.dataset.scbV22Initialized = 'true';

    var fabricDone = root.querySelector('.scb-fabric-done, [data-complete-step="fabric"]');
    var fabricHead = root.querySelector('.scb-fabric-head');
    var fabricGrid = root.querySelector('.scb-swatch-grid');

    function collapseFabricsV22(){
      root.classList.add('scb-fabric-collapsed');
      if(fabricGrid) fabricGrid.style.display = 'none';
      if(fabricDone) fabricDone.style.display = 'none';
      if(fabricHead){
        fabricHead.innerHTML = '<div class="scb-panel-kicker">Step 2</div><h2>Fabric selected</h2><button type="button" class="scb-step-toggle scb-fabric-reopen" data-reopen-fabrics>Change</button>';
        var reopen = fabricHead.querySelector('[data-reopen-fabrics]');
        if(reopen){
          reopen.addEventListener('click', function(){
            root.classList.remove('scb-fabric-collapsed');
            fabricHead.innerHTML = '<div class="scb-panel-kicker">Step 2</div><h2>Choose Fabrics</h2>';
            if(fabricGrid) fabricGrid.style.display = '';
            if(fabricDone) fabricDone.style.display = '';
          });
        }
      }
      var bow = root.querySelector('[data-step-section="bow"]');
      if(bow) bow.classList.remove('is-collapsed');
    }

    if(fabricDone){
      fabricDone.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        collapseFabricsV22();
      }, true);
    }

    // Ensure initial visual colors are set for SVG masks.
    root.style.setProperty('--scb-bow-ui-color', root.style.getPropertyValue('--scb-bow-ui-color') || '#B78792');
    root.style.setProperty('--scb-picot-ui-color', root.style.getPropertyValue('--scb-picot-ui-color') || '#111111');
  }

  function initAllV22(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV22);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV22);
  else initAllV22();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV22(root);
  });
})();


/* v23: lock fabric after Done, unlock on Change, and render 1/2 picot preview SVGs. */
(function(){
  function initV23(root){
    if(!root || root.dataset.scbV23Initialized === 'true') return;
    root.dataset.scbV23Initialized = 'true';

    var fabricLocked = false;
    var picotColors = [];

    var colorMap = {
      'Soft Pink': '#DBC8C8',
      'Moss Green': '#61735A',
      'Matte Black': '#050505'
    };

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function lockFabric(){
      fabricLocked = true;
      root.classList.add('scb-fabric-locked');
    }

    function unlockFabric(){
      fabricLocked = false;
      root.classList.remove('scb-fabric-locked');
    }

    // Block fabric editing when locked, before older handlers can apply fabric.
    qa('.scb-zone-group').forEach(function(zone){
      ['click','pointerdown','dragenter','dragover','drop'].forEach(function(type){
        zone.addEventListener(type, function(event){
          if(fabricLocked){
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      });
    });

    // Lock after fabric Done.
    qa('[data-complete-step="fabric"], .scb-fabric-done').forEach(function(btn){
      btn.addEventListener('click', function(){
        lockFabric();
      }, true);
    });

    // Unlock when user reopens fabric section.
    root.addEventListener('click', function(event){
      var target = event.target;
      if(target && (target.matches('[data-reopen-fabrics]') || target.closest('[data-reopen-fabrics]'))){
        unlockFabric();
      }
      if(target && (target.matches('[data-toggle-step="fabric"]') || target.closest('[data-toggle-step="fabric"]'))){
        unlockFabric();
      }
    }, true);

    function renderPicotPreview(){
      var previews = qa('[data-picot-preview]');
      previews.forEach(function(preview, index){
        var name = picotColors[index];
        if(!name){
          preview.classList.add('is-hidden');
          preview.style.removeProperty('background-color');
          preview.style.removeProperty('background-image');
          preview.removeAttribute('data-texture');
          return;
        }
        preview.classList.remove('is-hidden');
        preview.removeAttribute('data-texture');
        preview.style.removeProperty('background-image');
        preview.style.backgroundColor = colorMap[name] || '#111111';
      });
    }

    function syncFromActivePicot(){
      picotColors = qa('[data-color-kind="picot"].is-active').map(function(btn){
        return btn.getAttribute('data-color-name') || '';
      }).filter(Boolean).slice(0,2);
      renderPicotPreview();
    }

    qa('[data-color-kind="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(syncFromActivePicot, 0);
      }, true);
    });

    syncFromActivePicot();
  }

  function initAllV23(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV23);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV23);
  else initAllV23();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV23(root);
  });
})();


/* v27 pricing, sizes, and add-on cart wiring. */
(function(){
  function initV27(root){
    if(!root || root.dataset.scbV27Initialized === 'true') return;
    root.dataset.scbV27Initialized = 'true';

    var topVariants = {"XS":"45830775668934","S":"45830775701702","M":"45830775734470","L":"45830775767238"};
    var bottomVariants = {"XS":"45830770786502","S":"45830770819270","M":"45830770852038","L":"45830770884806"};
    var addonSequins = "45830789628102";
    var addonBead = "45830789529798";

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function getMode(){
      var active = root.querySelector('.scb-mode-btn.is-active');
      return active ? active.getAttribute('data-mode') : 'set';
    }
    function getTopSize(){ return (q('[data-top-size]') || {}).value || 'M'; }
    function getBottomSize(){ return (q('[data-bottom-size]') || {}).value || 'M'; }
    function choice(kind){
      var active = root.querySelector('[data-choice-kind="'+kind+'"].is-active');
      return active ? active.getAttribute('data-choice-value') : 'No';
    }
    function sequinsYes(){ return choice('sequins') === 'Yes'; }
    function laceYes(){ return true; }
    function beadYes(){ return choice('strap') === 'Bead'; }
    function activeStyleId(kind, fallback){
      var active = q('.scb-style-card[data-style-kind="'+kind+'"].is-active');
      return active ? active.getAttribute('data-style-id') : fallback;
    }
    function firstPicotColorOnlyForItem(itemType){
      if(itemType === 'Top') return activeStyleId('top', '') === 'top_2_layer';
      if(itemType === 'Bottom'){
        var bottomId = activeStyleId('bottom', '');
        return bottomId === 'bottom_2_layer' || bottomId === 'bottom_2_layer_hipster' || bottomId === 'bottom_2_layer_cheeky';
      }
      return false;
    }

    function updateSizeVisibility(){
      var mode = getMode();
      var topField = q('[data-top-size-field]');
      var bottomField = q('[data-bottom-size-field]');
      if(topField) topField.style.display = mode === 'bottom' ? 'none' : '';
      if(bottomField) bottomField.style.display = mode === 'top' ? 'none' : '';
    }

    function total(){
      var mode = getMode();
      var amount = mode === 'top' ? 75 : (mode === 'bottom' ? 80 : 155);
      if(sequinsYes()) amount += 20;
      if(beadYes()) amount += 5;
      return amount;
    }

    function updateTotal(){
      updateSizeVisibility();
      var mode = getMode();
      var label = mode === 'top' ? 'Top Only' : (mode === 'bottom' ? 'Bottom Only' : 'Top + Bottom Set');
      var price = q('[data-total-price]');
      var note = q('[data-total-note]');
      if(price) price.textContent = '$' + total();
      if(note){
        var bits = [label];
        if(mode !== 'bottom') bits.push('Top ' + getTopSize());
        if(mode !== 'top') bits.push('Bottom ' + getBottomSize());
        if(sequinsYes()) bits.push('+ Sequins');
        if(laceYes()) bits.push('Lace Trim');
        if(beadYes()) bits.push('+ Bead');
        note.textContent = bits.join(' · ');
      }
      var modeInput = q('[data-input-purchase-mode]');
      var topInput = q('[data-hidden-top-size]');
      var bottomInput = q('[data-hidden-bottom-size]');
      if(modeInput) modeInput.value = label;
      if(topInput) topInput.value = getTopSize();
      if(bottomInput) bottomInput.value = getBottomSize();
    }

    function selectedProperties(extra){
      var mode = getMode();
      var props = {
        "Customizer": "Salt Crystal Bikinis",
        "Purchase Mode": mode === 'top' ? 'Top Only' : (mode === 'bottom' ? 'Bottom Only' : 'Top + Bottom Set')
      };
      if(mode !== 'bottom') props["Top Size"] = getTopSize();
      if(mode !== 'top') props["Bottom Size"] = getBottomSize();

      qa('[data-zone-list] li').forEach(function(li){
        var k = li.querySelector('span') ? li.querySelector('span').textContent.trim() : '';
        var v = li.querySelector('strong') ? li.querySelector('strong').textContent.trim() : '';
        if(k && v) props[k] = v;
      });

      var bow = q('[data-input-bow-color]'); if(bow) props["Bow Color"] = bow.value;
      scbApplyPicotProperties(props, root, firstPicotColorOnlyForItem(extra && extra["Item Type"]));
      props["Add Sequins"] = sequinsYes() ? 'Yes' : 'No';
      var sequinColor = q('[data-input-sequin-color]'); if(sequinsYes() && sequinColor) props["Sequin Color"] = sequinColor.value || 'Rose Gold';
      props["Add Lace Trim"] = laceYes() ? 'Yes' : 'No';
      var laceColor = q('[data-input-lace-color]'); if(laceYes() && laceColor) props["Lace Trim Color"] = laceColor.value || 'Black';
      props["Strap Ends"] = beadYes() ? 'Bead' : 'Knot';

      if(extra) Object.keys(extra).forEach(function(k){ props[k] = extra[k]; });
      return props;
    }

    function cartItems(){
      var mode = getMode();
      var items = [];
      if(mode === 'top' || mode === 'set') {
        items.push({id: Number(topVariants[getTopSize()]), quantity: 1, properties: selectedProperties({"Item Type":"Top"})});
      }
      if(mode === 'bottom' || mode === 'set') {
        items.push({id: Number(bottomVariants[getBottomSize()]), quantity: 1, properties: selectedProperties({"Item Type":"Bottom"})});
      }
      if(sequinsYes()) items.push({id: Number(addonSequins), quantity: 1, properties: {"Customizer Add-on":"Sequins", "For":"Custom Bikini"}});
      if(beadYes()) items.push({id: Number(addonBead), quantity: 1, properties: {"Customizer Add-on":"Bead Strap Finish", "For":"Custom Bikini"}});
      return items;
    }

    qa('.scb-mode-btn,[data-top-size],[data-bottom-size],[data-choice-kind],[data-color-kind]').forEach(function(el){
      el.addEventListener('click', function(){ setTimeout(updateTotal, 0); }, true);
      el.addEventListener('change', function(){ setTimeout(updateTotal, 0); }, true);
    });

    var form = null; // v30 owns Ajax cart submission with layer-specific variants.
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = form.querySelector('button[type="submit"]');
        if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items: cartItems()})
        }).then(function(resp){
          if(!resp.ok) throw new Error('Cart add failed');
          return resp.json();
        }).then(function(){
          window.location.href = '/cart';
        }).catch(function(){
          alert('Could not add to cart. Please check that all products/add-ons are active.');
          if(btn){ btn.disabled = false; btn.textContent = 'Add customized bikini to cart'; }
        });
      }, true);
    }

    updateTotal();
  }

  function initAllV27(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV27); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV27);
  else initAllV27();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV27(root);
  });
})();


/* v27 size-collapse-only */
(function(){
  function initSizeCollapseOnly(root){
    if(!root || root.dataset.scbSizeCollapseOnly === 'true') return;
    root.dataset.scbSizeCollapseOnly = 'true';

    var section = root.querySelector('[data-size-section]');
    var done = root.querySelector('[data-complete-step="size"]');
    var title = root.querySelector('[data-size-title]');
    var summary = root.querySelector('[data-size-summary]');
    var topSelect = root.querySelector('[data-top-size]');
    var bottomSelect = root.querySelector('[data-bottom-size]');

    function mode(){
      var active = root.querySelector('.scb-mode-btn.is-active');
      return active ? active.getAttribute('data-mode') : 'set';
    }
    function topSize(){ return topSelect ? topSelect.value : 'M'; }
    function bottomSize(){ return bottomSelect ? bottomSelect.value : 'M'; }

    function summaryText(){
      var m = mode();
      if(m === 'top') return 'Top ' + topSize();
      if(m === 'bottom') return 'Bottom ' + bottomSize();
      return 'Top ' + topSize() + ' · Bottom ' + bottomSize();
    }

    function updateSummary(){
      if(summary) summary.textContent = summaryText();
    }

    function collapse(){
      if(!section) return;
      updateSummary();
      section.classList.add('scb-size-collapsed');
      if(title) title.textContent = 'Size selected';
      if(summary) summary.hidden = false;

      if(!section.querySelector('[data-reopen-size]')){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'scb-size-change';
        btn.setAttribute('data-reopen-size', '');
        btn.textContent = 'Change';
        btn.addEventListener('click', open);
        section.appendChild(btn);
      }
    }

    function open(){
      if(!section) return;
      section.classList.remove('scb-size-collapsed');
      if(title) title.textContent = 'Choose size';
      if(summary) summary.hidden = true;
      var btn = section.querySelector('[data-reopen-size]');
      if(btn) btn.remove();
    }

    if(done){
      done.addEventListener('click', function(e){
        e.preventDefault();
        collapse();
      }, true);
    }

    [topSelect, bottomSelect].forEach(function(sel){
      if(sel) sel.addEventListener('change', updateSummary, true);
    });

    root.querySelectorAll('.scb-mode-btn').forEach(function(btn){
      btn.addEventListener('click', function(){ setTimeout(updateSummary, 0); }, true);
    });

    updateSummary();
  }

  function initAll(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initSizeCollapseOnly);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initSizeCollapseOnly(root);
  });
})();

/* v30: layer-specific pricing + variants + simple-top bow/picot rules */
(function(){
  function initV30(root){
    if(!root || root.dataset.scbV30Initialized === 'true') return;
    root.dataset.scbV30Initialized = 'true';

    var topVariants = {
      "top_1_layer": {"XS":"45830838321350","S":"45830838354118","M":"45830838386886","L":"45830838419654"},
      "top_2_layer": {"XS":"45830837338310","S":"45830837371078","M":"45830837403846","L":"45830837436614"},
      "top_3_layer": {"XS":"45830837141702","S":"45830837174470","M":"45830837207238","L":"45830837240006"},
      "top_4_layer": {"XS":"45830775668934","S":"45830775701702","M":"45830775734470","L":"45830775767238"}
    };
    var bottomVariants = {
      "bottom_1_layer": {"XS":"45830839238854","S":"45830839271622","M":"45830839304390","L":"45830839337158"},
      "bottom_2_layer": {"XS":"45830839435462","S":"45830839468230","M":"45830839500998","L":"45830839533766"},
      "bottom_3_layer": {"XS":"45830839599302","S":"45830839632070","M":"45830839664838","L":"45830839697606"},
      "bottom_4_layer": {"XS":"45830770786502","S":"45830770819270","M":"45830770852038","L":"45830770884806"},
      "bottom_side_tie_shorts": {"XS":"45976275583174","S":"45976275615942","M":"45976275648710","L":"45976275681478"},
      "bottom_hipster": {"XS":"45976264671430","S":"45976264704198","M":"45976264736966","L":"45976264769734"},
      "bottom_2_layer_hipster": {"XS":"45976266014918","S":"45976266047686","M":"45976266080454","L":"45976266113222"},
      "bottom_cheeky": {"XS":"45976257265862","S":"45976257298630","M":"45976257331398","L":"45976257364166"},
      "bottom_2_layer_cheeky": {"XS":"45976261427398","S":"45976261460166","M":"45976261492934","L":"45976261525702"}
    };
    var topPrices = {"top_1_layer":40,"top_2_layer":50,"top_3_layer":65,"top_4_layer":75};
    var bottomPrices = {"bottom_1_layer":45,"bottom_2_layer":55,"bottom_3_layer":70,"bottom_4_layer":80};
    var addonSequins = "45830789628102";
    var addonBead = "45830789529798";

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function mode(){ var a=q('.scb-mode-btn.is-active'); return a ? a.getAttribute('data-mode') : 'set'; }
    function topStyle(){ var a=q('.scb-style-card[data-style-kind="top"].is-active'); return a ? a.getAttribute('data-style-id') : 'top_4_layer'; }
    function bottomStyle(){ var a=q('.scb-style-card[data-style-kind="bottom"].is-active'); return a ? a.getAttribute('data-style-id') : 'bottom_4_layer'; }
    function topStyleName(){ var a=q('.scb-style-card[data-style-kind="top"].is-active'); return a ? (a.getAttribute('data-style-name') || a.textContent.trim()) : '4 Layer Top'; }
    function bottomStyleName(){ var a=q('.scb-style-card[data-style-kind="bottom"].is-active'); return a ? (a.getAttribute('data-style-name') || a.textContent.trim()) : '4 Layer Adjustable'; }
    function topSize(){ var x=q('[data-top-size]'); return x ? x.value : 'M'; }
    function bottomSize(){ var x=q('[data-bottom-size]'); return x ? x.value : 'M'; }
    function choice(kind){ var a=q('[data-choice-kind="'+kind+'"].is-active'); return a ? a.getAttribute('data-choice-value') : 'No'; }
    function sequinsYes(){ return choice('sequins') === 'Yes'; }
    function laceYes(){ return true; }
    function beadYes(){ return choice('strap') === 'Bead'; }
    function firstPicotColorOnlyForItem(itemType){
      if(itemType === 'Top') return topStyle() === 'top_2_layer';
      if(itemType === 'Bottom'){
        var bottomId = bottomStyle();
        return bottomId === 'bottom_2_layer' || bottomId === 'bottom_2_layer_hipster' || bottomId === 'bottom_2_layer_cheeky';
      }
      return false;
    }
    function styleNeedsLink(kind, styleId){
      if(kind === 'top') return !topVariants[styleId];
      return !bottomVariants[styleId];
    }
    function previewOnlySelection(){
      var m = mode();
      return (m !== 'bottom' && styleNeedsLink('top', topStyle())) || (m !== 'top' && styleNeedsLink('bottom', bottomStyle()));
    }
    function styleHasBow(styleId){
      return styleId === 'top_3_layer' || styleId === 'top_4_layer' || styleId === 'bottom_3_layer' || styleId === 'bottom_4_layer' || styleId === 'bottom_side_tie_shorts' || styleId === 'bottom_hipster' || styleId === 'bottom_2_layer_hipster' || styleId === 'bottom_cheeky' || styleId === 'bottom_2_layer_cheeky';
    }
    function bowAvailable(){
      var m = mode();
      return (m !== 'bottom' && styleHasBow(topStyle())) || (m !== 'top' && styleHasBow(bottomStyle()));
    }
    function bowRequired(){
      var m = mode();
      return (m === 'top' && topStyle() === 'top_4_layer') || (m === 'set' && (topStyle() === 'top_4_layer' || bottomStyle() === 'bottom_4_layer'));
    }
    function activeBowName(){
      var btn = q('[data-color-kind="bow"].is-active');
      return btn ? (btn.getAttribute('data-color-name') || '') : '';
    }
    function userBowChoiceName(){
      return root.dataset.scbBowUserChoiceName || '';
    }
    function setBowSelection(name){
      qa('[data-color-kind="bow"]').forEach(function(btn){
        btn.classList.toggle('is-active', (btn.getAttribute('data-color-name') || '') === name);
      });
      var bow = q('[data-input-bow-color]');
      var summary = q('[data-bow-summary]');
      if(bow) bow.value = name;
      if(summary) summary.textContent = name;
    }
    function oneColorPicot(){
      return hasTwoLayerPicot() && !hasFourLayerPicot();
    }
    function hasTwoLayerPicot(){
      var m = mode();
      return (m !== 'bottom' && topStyle() === 'top_2_layer') || (m !== 'top' && (bottomStyle() === 'bottom_2_layer' || bottomStyle() === 'bottom_2_layer_hipster' || bottomStyle() === 'bottom_2_layer_cheeky'));
    }
    function hasFourLayerPicot(){
      var m = mode();
      return (m !== 'bottom' && topStyle() === 'top_4_layer') || (m !== 'top' && bottomStyle() === 'bottom_4_layer');
    }

    function enforceRules(){
      var hasBowOption = bowAvailable();
      var mustChooseBow = hasBowOption && bowRequired();
      root.classList.toggle('scb-no-bow-option', !hasBowOption);
      root.classList.toggle('scb-bow-required', mustChooseBow);
      root.classList.toggle('scb-bow-optional', hasBowOption && !mustChooseBow);
      if(hasBowOption){
        var currentBow = activeBowName();
        if(mustChooseBow && (!currentBow || currentBow === 'None')) setBowSelection('Charcoal');
        if(!mustChooseBow){
          var optionalBow = userBowChoiceName() || 'None';
          if(currentBow !== optionalBow) setBowSelection(optionalBow);
        }
      }
      root.classList.toggle('scb-picot-one-only', oneColorPicot());
      var picotLimitNote = q('[data-picot-limit-note]');
      if(picotLimitNote) picotLimitNote.style.display = hasFourLayerPicot() ? '' : 'none';
      if(oneColorPicot()){
        var activePicot = qa('[data-color-kind="picot"].is-active');
        activePicot.slice(1).forEach(function(btn){ btn.classList.remove('is-active'); });
      }
    }

    function updateSizeVisibility(){
      var m=mode(), topField=q('[data-top-size-field]'), bottomField=q('[data-bottom-size-field]');
      if(topField) topField.style.display = m === 'bottom' ? 'none' : '';
      if(bottomField) bottomField.style.display = m === 'top' ? 'none' : '';
    }

    function total(){
      var m=mode(), amount=0;
      if(m==='top' || m==='set') amount += topPrices[topStyle()] || 75;
      if(m==='bottom' || m==='set') amount += bottomPrices[bottomStyle()] || 80;
      if(sequinsYes()) amount += 20;
      if(beadYes()) amount += 5;
      return amount;
    }

    function updateTotal(){
      enforceRules(); updateSizeVisibility();
      var m=mode(), label=m==='top'?'Top Only':(m==='bottom'?'Bottom Only':'Top + Bottom Set');
      var price=q('[data-total-price]'), note=q('[data-total-note]');
      if(price) price.textContent = previewOnlySelection() ? 'Preview only' : '$' + total();
      if(note){
        var bits=[label];
        if(m!=='bottom') bits.push(topStyleName() + ' ' + topSize());
        if(m!=='top') bits.push(bottomStyleName() + ' ' + bottomSize());
        if(sequinsYes()) bits.push('+ Sequins');
        if(laceYes()) bits.push('Lace Trim');
        if(beadYes()) bits.push('+ Bead');
        if(previewOnlySelection()) bits.push('Not linked yet');
        note.textContent = bits.join(' · ');
      }
      var form=q('[data-scb-cart-form]');
      var btn=form ? form.querySelector('button[type="submit"]') : null;
      if(btn){
        if(previewOnlySelection()){
          btn.disabled = true;
          btn.textContent = 'Preview only - not linked yet';
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.disabled = false;
          btn.textContent = 'Add customized bikini to cart';
          btn.removeAttribute('aria-disabled');
        }
      }
    }

    function props(extra){
      var m=mode(), p={"Customizer":"Salt Crystal Bikinis","Purchase Mode":m==='top'?'Top Only':(m==='bottom'?'Bottom Only':'Top + Bottom Set')};
      if(m!=='bottom'){ p["Top Style"]=topStyleName(); p["Top Size"]=topSize(); }
      if(m!=='top'){ p["Bottom Style"]=bottomStyleName(); p["Bottom Size"]=bottomSize(); }
      qa('[data-zone-list] li').forEach(function(li){
        var k=li.querySelector('span') ? li.querySelector('span').textContent.trim() : '';
        var v=li.querySelector('strong') ? li.querySelector('strong').textContent.trim() : '';
        if(k && v) p[k]=v;
      });
      var bow=q('[data-input-bow-color]'); if(bow && bowAvailable()) p["Bow Color"]=bow.value || 'None';
      scbApplyPicotProperties(p, root, firstPicotColorOnlyForItem(extra && extra["Item Type"]));
      p["Add Sequins"]=sequinsYes()?'Yes':'No';
      var sequin=q('[data-input-sequin-color]'); if(sequinsYes() && sequin) p["Sequin Color"]=sequin.value || 'Rose Gold';
      p["Add Lace Trim"]=laceYes()?'Yes':'No';
      var lace=q('[data-input-lace-color]'); if(laceYes() && lace) p["Lace Trim Color"]=lace.value || 'Black';
      p["Strap Ends"]=beadYes()?'Bead':'Knot';
      if(extra) Object.keys(extra).forEach(function(k){ p[k]=extra[k]; });
      return p;
    }

    function cartItems(){
      enforceRules();
      var m=mode(), items=[];
      if(m==='top' || m==='set') items.push({id:Number(topVariants[topStyle()][topSize()]),quantity:1,properties:props({"Item Type":"Top"})});
      if(m==='bottom' || m==='set') items.push({id:Number(bottomVariants[bottomStyle()][bottomSize()]),quantity:1,properties:props({"Item Type":"Bottom"})});
      if(sequinsYes()) items.push({id:Number(addonSequins),quantity:1,properties:{"Customizer Add-on":"Sequins","For":"Custom Bikini"}});
      if(beadYes()) items.push({id:Number(addonBead),quantity:1,properties:{"Customizer Add-on":"Bead Strap Finish","For":"Custom Bikini"}});
      return items;
    }

    qa('.scb-mode-btn,.scb-style-card,[data-top-size],[data-bottom-size],[data-choice-kind],[data-color-kind]').forEach(function(el){
      el.addEventListener('click', function(){ setTimeout(updateTotal,0); }, true);
      el.addEventListener('change', function(){ setTimeout(updateTotal,0); }, true);
    });
    qa('[data-color-kind="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(oneColorPicot() && !btn.classList.contains('is-active')){
          qa('[data-color-kind="picot"].is-active').forEach(function(x){ x.classList.remove('is-active'); });
        }
        setTimeout(updateTotal,0);
      }, true);
    });
    qa('[data-color-kind="bow"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        root.dataset.scbBowUserChoiceName = btn.getAttribute('data-color-name') || '';
      }, true);
    });

    var form=q('[data-scb-cart-form]');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault(); e.stopImmediatePropagation();
        var btn=form.querySelector('button[type="submit"]');
        if(btn){ btn.disabled=true; btn.textContent='Adding...'; }
        var payload;
        try {
          payload = {items:cartItems()};
        } catch(err) {
          console.error('SCB cart payload failed', err);
          alert('Could not add to cart. Please check that all products/add-ons are active.');
          if(btn){ btn.disabled=false; btn.textContent='Add customized bikini to cart'; }
          return;
        }
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
          .then(function(resp){ if(!resp.ok) throw new Error('Cart add failed'); return resp.json(); })
          .then(function(){ window.location.href='/cart'; })
          .catch(function(){ alert('Could not add to cart. Please check that all products/add-ons are active.'); if(btn){ btn.disabled=false; btn.textContent='Add customized bikini to cart'; }});
      }, true);
    }
    updateTotal();
  }
  function initAllV30(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV30); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAllV30); else initAllV30();
  document.addEventListener('shopify:section:load', function(event){ var root=event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null; if(root) initV30(root); });
})();


/* v34 safe optional layer loader: keeps Liquid section small and loads add-on layers as assets */
(function(){
  function initV34(root){
    if(!root || root.dataset.scbV34Initialized === 'true') return;
    root.dataset.scbV34Initialized = 'true';

    var assetScript = root.querySelector('[data-scb-optional-assets]');
    var assetMap = {};
    try { assetMap = assetScript ? JSON.parse(assetScript.textContent) : {}; } catch(e) { assetMap = {}; }

    var colorMaps = {
      bow: {'None':'transparent','Dusty Rose':'#B78792','Charcoal':'#111111','Mocha':'#7B6A58','Moss':'#61735A','Baby Blue':'#A9C9DF'},
      picot: {'Soft Pink':'#DBC8C8','Shimmery Black':'#191919','Moss Green':'#61735A','Matte Black':'#050505'},
      sequins: {'Rose Gold':'#F7B7A3','Chrome Black':'#3C3F44'},
      lace: {'Black':'#111111','Baby Pink':'#DABEBC','Brown':'#5E4736'}
    };

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function activeStyle(kind){
      var btn = q('.scb-style-card[data-style-kind="'+kind+'"].is-active');
      return btn ? btn.getAttribute('data-style-id') : (kind === 'top' ? 'top_4_layer' : 'bottom_4_layer');
    }
    function activeColor(kind){
      var btn = q('[data-color-kind="'+kind+'"].is-active');
      return btn ? (btn.getAttribute('data-color-name') || '') : '';
    }
    function activePicotColors(){
      return qa('[data-color-kind="picot"].is-active').map(function(btn){ return btn.getAttribute('data-color-name') || ''; }).filter(Boolean).slice(0,2);
    }
    function choice(kind){
      var active = q('[data-choice-kind="'+kind+'"].is-active');
      return active ? active.getAttribute('data-choice-value') : 'No';
    }
    function slotForKind(kind){ return q('[data-slot="'+kind+'"]'); }
    function mainSvg(kind){ return q('.scb-template-svg[data-style-kind="'+kind+'"].is-visible'); }
    function activeOverlay(kind){
      var slot = slotForKind(kind);
      var styleId = activeStyle(kind);
      return slot ? slot.querySelector('.scb-optional-svg[data-style-kind="'+kind+'"][data-style-id="'+styleId+'"]') : null;
    }
    var customBottomFrontOutlineStyles = {
      bottom_side_tie_shorts: true,
      bottom_hipster: true,
      bottom_2_layer_hipster: true,
      bottom_cheeky: true,
      bottom_2_layer_cheeky: true
    };

    function syncFrontOutline(kind, overlay){
      if(!overlay || !customBottomFrontOutlineStyles[overlay.getAttribute('data-style-id')]) return;
      var existing = overlay.querySelector('.scb-overlay-outline-layer');
      if(existing) existing.remove();
      var main = mainSvg(kind);
      var outline = main ? main.querySelector('.scb-outline-layer') : null;
      if(!outline) return;
      var clone = outline.cloneNode(true);
      clone.classList.add('scb-overlay-outline-layer');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('style', 'pointer-events:none');
      clone.querySelectorAll('[id]').forEach(function(node){ node.removeAttribute('id'); });
      var firstBow = overlay.querySelector('.scb-optional-bow');
      if(firstBow) overlay.insertBefore(clone, firstBow);
      else overlay.appendChild(clone);
    }

    function syncOverlayPosition(kind){
      var slot = slotForKind(kind);
      var overlay = activeOverlay(kind);
      var main = mainSvg(kind);
      if(!slot || !overlay || !main) return;
      var sr = slot.getBoundingClientRect();
      var mr = main.getBoundingClientRect();
      overlay.style.left = (mr.left - sr.left) + 'px';
      overlay.style.top = (mr.top - sr.top) + 'px';
      overlay.style.width = mr.width + 'px';
      overlay.style.height = mr.height + 'px';
    }

    function loadOverlay(kind){
      var styleId = activeStyle(kind);
      var slot = slotForKind(kind);
      if(!slot) return Promise.resolve(null);
      var existing = activeOverlay(kind);
      if(existing && existing.getAttribute('data-style-id') === styleId) {
        qa('.scb-optional-svg[data-style-kind="'+kind+'"]').forEach(function(svg){
          if(svg !== existing) svg.remove();
        });
        syncFrontOutline(kind, existing);
        syncOverlayPosition(kind);
        return Promise.resolve(existing);
      }
      qa('.scb-optional-svg[data-style-kind="'+kind+'"]').forEach(function(svg){ svg.remove(); });
      var url = assetMap[styleId];
      if(!url) return Promise.resolve(null);
      return fetch(url).then(function(resp){ return resp.text(); }).then(function(svgText){
        if(activeStyle(kind) !== styleId) return null;
        qa('.scb-optional-svg[data-style-kind="'+kind+'"]').forEach(function(svg){ svg.remove(); });
        var holder = document.createElement('div');
        holder.innerHTML = svgText.trim();
        var svg = holder.querySelector('svg');
        if(!svg) return null;
        svg.classList.add('scb-optional-svg');
        svg.setAttribute('data-style-kind', kind);
        svg.setAttribute('data-style-id', styleId);
        slot.appendChild(svg);
        syncFrontOutline(kind, svg);
        syncOverlayPosition(kind);
        return svg;
      }).catch(function(){ return null; });
    }

    function hasOptional(type){
      return !!root.querySelector('.scb-optional-svg [data-optional-type^="'+type+'"]');
    }

    function supportsPicot(kind){
      var styleId = activeStyle(kind);
      return !!root.querySelector('.scb-optional-svg[data-style-kind="'+kind+'"][data-style-id="'+styleId+'"] [data-optional-type^="picot"]');
    }

    function picotAvailableForMode(){
      var activeMode = q('.scb-mode-btn.is-active');
      var currentMode = activeMode ? activeMode.getAttribute('data-mode') : 'set';
      if(currentMode === 'top') return supportsPicot('top');
      if(currentMode === 'bottom') return supportsPicot('bottom');
      return supportsPicot('top') || supportsPicot('bottom');
    }

    function updateOptionSections(){
      var bowSection = q('[data-step-section="bow"]');
      var picotSection = q('[data-step-section="picot"]');
      var sequinsSection = q('[data-step-section="sequins"]');
      var laceSection = q('[data-step-section="lace"]');
      if(bowSection) bowSection.style.display = hasOptional('bow') ? '' : 'none';
      if(picotSection) picotSection.style.display = picotAvailableForMode() ? '' : 'none';
      if(sequinsSection) sequinsSection.style.display = hasOptional('sequins') ? '' : 'none';
      if(laceSection) laceSection.style.display = hasOptional('lace') ? '' : 'none';
    }

    function updateColorsAndVisibility(){
      var bowName = activeColor('bow');
      var bowColor = colorMaps.bow[bowName] || '#B78792';
      var picotNames = activePicotColors();
      var picot1 = colorMaps.picot[picotNames[0]] || 'transparent';
      var picot2 = colorMaps.picot[picotNames[1]] || picot1;
      var seqColor = colorMaps.sequins[activeColor('sequins')] || '#F7B7A3';
      var laceColor = colorMaps.lace[activeColor('lace')] || '#111111';

      root.style.setProperty('--scb-bow-layer-color', bowColor);
      root.style.setProperty('--scb-picot-color-1', picot1);
      root.style.setProperty('--scb-picot-color-2', picot2);
      root.style.setProperty('--scb-sequin-layer-color', seqColor);
      root.style.setProperty('--scb-lace-layer-color', laceColor);

      var showBow = !!bowName && bowName !== 'None';
      var showPicot = picotNames.length > 0;
      var showSequins = choice('sequins') === 'Yes';
      var showLace = true;

      qa('.scb-optional-svg').forEach(function(svg){
        svg.classList.toggle('scb-show-bow', showBow);
        svg.classList.toggle('scb-show-picot', showPicot);
        svg.classList.toggle('scb-show-sequins', showSequins);
        svg.classList.toggle('scb-show-lace', showLace);
      });
    }

    function refresh(){
      Promise.all([loadOverlay('top'), loadOverlay('bottom')]).then(function(){
        updateOptionSections();
        updateColorsAndVisibility();
        syncOverlayPositions();
      });
    }

    function syncOverlayPositions(){
      syncOverlayPosition('top');
      syncOverlayPosition('bottom');
    }

    root.scbRefreshOptionalOverlays = refresh;
    root.scbSyncOptionalOverlayPositions = syncOverlayPositions;

    qa('.scb-style-card,.scb-mode-btn,[data-color-kind],[data-choice-kind]').forEach(function(el){
      el.addEventListener('click', function(){ setTimeout(refresh, 0); }, true);
      el.addEventListener('change', function(){ setTimeout(refresh, 0); }, true);
    });
    window.addEventListener('resize', function(){
      syncOverlayPosition('top');
      syncOverlayPosition('bottom');
    });

    refresh();
  }

  function initAllV34(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV34); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV34);
  else initAllV34();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV34(root);
  });
})();


/* v35: subtle contrast outlines for bows/picot/sequins + choose sequins center vs outer */
(function(){
  function initV35(root){
    if(!root || root.dataset.scbV35Initialized === 'true') return;
    root.dataset.scbV35Initialized = 'true';
    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function hexToRgb(hex){
      if(!hex) return null;
      hex = hex.replace('#','').trim();
      if(hex.length === 3) hex = hex.split('').map(function(c){ return c + c; }).join('');
      if(hex.length !== 6) return null;
      return {r: parseInt(hex.slice(0,2),16), g: parseInt(hex.slice(2,4),16), b: parseInt(hex.slice(4,6),16)};
    }
    function outlineForHex(hex){
      var rgb = hexToRgb(hex);
      if(!rgb) return '#111111';
      var lum = (0.2126*rgb.r + 0.7152*rgb.g + 0.0722*rgb.b) / 255;
      return lum > 0.6 ? '#111111' : '#ffffff';
    }
    function activeColor(kind){ var btn = q('[data-color-kind="'+kind+'"].is-active'); return btn ? (btn.getAttribute('data-color-value') || '') : ''; }
    function activePicotHexes(){ return qa('[data-color-kind="picot"].is-active').map(function(btn){ return btn.getAttribute('data-color-value') || ''; }).filter(Boolean).slice(0,2); }
    function choice(kind){ var btn = q('[data-choice-kind="'+kind+'"].is-active'); return btn ? (btn.getAttribute('data-choice-value') || '') : ''; }

    function updateV35(){
      var bowHex = activeColor('bow') || '#B78792';
      var seqHex = activeColor('sequins') || '#F7B7A3';
      var picots = activePicotHexes();
      var pic1 = picots[0] || '#DBC8C8';
      var pic2 = picots[1] || pic1;
      root.style.setProperty('--scb-bow-outline-color', outlineForHex(bowHex));
      root.style.setProperty('--scb-sequin-outline-color', outlineForHex(seqHex));
      root.style.setProperty('--scb-picot-outline-color-1', outlineForHex(pic1));
      root.style.setProperty('--scb-picot-outline-color-2', outlineForHex(pic2));

      var placement = 'Center Inlay';
      var placementInput = q('[data-input-sequin-placement]');
      if(placementInput) placementInput.value = placement;

      var seqDep = q('[data-dependent="sequins"]');
      var seqYes = choice('sequins') === 'Yes';
      if(seqDep) seqDep.hidden = !seqYes;

      var summary = q('[data-sequin-summary]');
      if(summary){
        var colorBtn = q('[data-color-kind="sequins"].is-active');
        var colorName = colorBtn ? (colorBtn.getAttribute('data-color-name') || 'Rose Gold') : 'Rose Gold';
        summary.textContent = seqYes ? ('Yes · ' + colorName) : 'No';
      }

      qa('.scb-optional-svg').forEach(function(svg){
        svg.classList.remove('scb-sequin-placement-center','scb-sequin-placement-outer');
        svg.classList.add('scb-sequin-placement-center');
      });
    }

    qa('[data-color-kind],[data-choice-kind]').forEach(function(el){
      el.addEventListener('click', function(){ setTimeout(updateV35, 0); }, true);
      el.addEventListener('change', function(){ setTimeout(updateV35, 0); }, true);
    });
    updateV35();
  }
  function initAllV35(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV35); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV35); else initAllV35();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV35(root);
  });
})();


/* v38: bow only after explicit choice; hide sequin placement for outer-only styles */
(function(){
  function initV38(root){
    if(!root || root.dataset.scbV38Initialized === 'true') return;
    root.dataset.scbV38Initialized = 'true';
    var userPickedBow = true;

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function visibleOptionalSvgs(){
      return qa('.scb-optional-svg').filter(function(svg){
        var kind = svg.getAttribute('data-style-kind');
        var modeBtn = q('.scb-mode-btn.is-active');
        var mode = modeBtn ? modeBtn.getAttribute('data-mode') : 'set';
        return mode === 'set' || mode === kind;
      });
    }

    function activeColor(kind){
      var btn = q('[data-color-kind="'+kind+'"].is-active');
      return btn ? (btn.getAttribute('data-color-name') || '') : '';
    }

    function hasVisibleOptional(type){
      return visibleOptionalSvgs().some(function(svg){
        return !!svg.querySelector('[data-optional-type^="'+type+'"]');
      });
    }

    function selectedSequinPlacement(){
      return 'Center Inlay';
    }

    function updateV38(){
      var coal = q('[data-color-kind="bow"][data-color-name="Charcoal"]');
      var none = q('[data-color-kind="bow"][data-color-name="None"]');
      var bowRequired = root.classList.contains('scb-bow-required');
      if(bowRequired && (!activeColor('bow') || activeColor('bow') === 'None') && coal){
        qa('[data-color-kind="bow"]').forEach(function(btn){ btn.classList.toggle('is-active', btn === coal); });
      }
      if(!bowRequired && !activeColor('bow') && none){
        qa('[data-color-kind="bow"]').forEach(function(btn){ btn.classList.toggle('is-active', btn === none); });
      }
      var bowColor = activeColor('bow');
      var bowSelected = (bowRequired || userPickedBow) && !!bowColor && bowColor !== 'None';
      root.classList.toggle('scb-show-bow', bowSelected);
      qa('.scb-optional-svg').forEach(function(svg){
        svg.classList.toggle('scb-show-bow', bowSelected);
      });
      var bowSummary = q('[data-bow-summary]');
      var bowInput = q('[data-input-bow-color]');
      if(!bowSelected){
        if(bowSummary) bowSummary.textContent = bowColor === 'None' ? 'None' : 'Choose color';
        if(bowInput) bowInput.value = bowColor === 'None' ? 'None' : '';
      } else {
        if(bowSummary) bowSummary.textContent = bowColor;
        if(bowInput) bowInput.value = bowColor;
      }

      // Sequins are center-inlay only.
      var placementWrap = q('[data-option-group="sequin-placement"]');
      var placementSubhead = placementWrap ? placementWrap.previousElementSibling : null;
      var placementInput = q('[data-input-sequin-placement]');
      if(placementWrap){
        placementWrap.style.display = 'none';
        if(placementSubhead && placementSubhead.classList && placementSubhead.classList.contains('scb-option-subhead-placement')){
          placementSubhead.style.display = 'none';
        }
      }
      if(placementInput) placementInput.value = 'Center Inlay';

      var placement = selectedSequinPlacement();
      qa('.scb-optional-svg').forEach(function(svg){
        svg.classList.remove('scb-sequin-placement-center', 'scb-sequin-placement-outer');
        svg.classList.add('scb-sequin-placement-center');
      });
    }

    qa('[data-color-kind="bow"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        userPickedBow = (btn.getAttribute('data-color-name') || '') !== 'None';
        setTimeout(updateV38, 0);
      }, true);
    });
    qa('.scb-style-card,.scb-mode-btn,[data-choice-kind],[data-color-kind]').forEach(function(el){
      el.addEventListener('click', function(){ setTimeout(updateV38, 75); }, true);
      el.addEventListener('change', function(){ setTimeout(updateV38, 75); }, true);
    });

    setTimeout(updateV38, 250);
  }
  function initAllV38(){ document.querySelectorAll('[data-scb-customizer]').forEach(initV38); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV38);
  else initAllV38();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV38(root);
  });
})();


/* v42 real picot fix: preserve customer click order, not DOM button order */
(function(){
  function initV42Picot(root){
    if(!root || root.dataset.scbV42Picot === 'true') return;
    root.dataset.scbV42Picot = 'true';

    var order = [];

    var colorMap = {
      'Soft Pink': '#DBC8C8',
      'Shimmery Black': '#191919',
      'Moss Green': '#61735A',
      'Matte Black': '#050505'
    };

    function outlineFor(hex){
      if(!hex || hex === 'transparent') return '#111111';
      var h = hex.replace('#','');
      if(h.length !== 6) return '#111111';
      var r = parseInt(h.slice(0,2),16), g = parseInt(h.slice(2,4),16), b = parseInt(h.slice(4,6),16);
      return ((0.2126*r + 0.7152*g + 0.0722*b) / 255) > 0.6 ? '#111111' : '#ffffff';
    }

    function isSimpleTop(){
      var top = root.querySelector('.scb-style-card[data-style-kind="top"].is-active');
      var bottom = root.querySelector('.scb-style-card[data-style-kind="bottom"].is-active');
      var modeBtn = root.querySelector('.scb-mode-btn.is-active');
      var mode = modeBtn ? modeBtn.getAttribute('data-mode') : 'set';
      var topId = top ? top.getAttribute('data-style-id') : '';
      var bottomId = bottom ? bottom.getAttribute('data-style-id') : '';
      var hasTwo = (mode !== 'bottom' && topId === 'top_2_layer') || (mode !== 'top' && (bottomId === 'bottom_2_layer' || bottomId === 'bottom_2_layer_hipster' || bottomId === 'bottom_2_layer_cheeky'));
      var hasFour = (mode !== 'bottom' && topId === 'top_4_layer') || (mode !== 'top' && bottomId === 'bottom_4_layer');
      return hasTwo && !hasFour;
    }

    function syncOrderFromActiveIfEmpty(){
      if(order.length) return;
      Array.prototype.slice.call(root.querySelectorAll('[data-color-kind="picot"].is-active')).forEach(function(btn){
        var name = btn.getAttribute('data-color-name') || '';
        if(name && order.indexOf(name) === -1) order.push(name);
      });
      order = order.slice(0, isSimpleTop() ? 1 : 2);
    }

    function enforceClassesFromOrder(){
      root.querySelectorAll('[data-color-kind="picot"]').forEach(function(btn){
        var name = btn.getAttribute('data-color-name') || '';
        btn.classList.toggle('is-active', order.indexOf(name) !== -1);
      });
    }

    function update(){
      if(isSimpleTop()) order = order.slice(0,1);
      syncOrderFromActiveIfEmpty();
      enforceClassesFromOrder();

      var first = colorMap[order[0]] || 'transparent';
      var second = colorMap[order[1]] || first;

      root.style.setProperty('--scb-picot-color-1', first);
      root.style.setProperty('--scb-picot-color-2', second);
      root.style.setProperty('--scb-picot-outline-color-1', outlineFor(first));
      root.style.setProperty('--scb-picot-outline-color-2', outlineFor(second));

      scbSyncPicotInputs(root, order);

      var summary = root.querySelector('[data-picot-summary]');
      if(summary) summary.textContent = order.length ? order.join(', ') : (isSimpleTop() ? 'Choose 1 color' : 'Choose 1 or 2');

      // Keep optional layers visible when a picot color is selected.
      root.querySelectorAll('.scb-optional-svg').forEach(function(svg){
        svg.classList.toggle('scb-show-picot', order.length > 0);
      });
    }

    root.querySelectorAll('[data-color-kind="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(event){
        var name = btn.getAttribute('data-color-name') || '';
        if(!name) return;

        var currentlySelected = order.indexOf(name) !== -1;

        if(currentlySelected) {
          order = order.filter(function(x){ return x !== name; });
        } else {
          if(isSimpleTop()) {
            order = [name];
          } else {
            if(order.length >= 2) order.shift();
            order.push(name);
          }
        }

        // Stop older controllers from reinterpreting selection by DOM order.
        event.preventDefault();
        event.stopImmediatePropagation();

        update();
      }, true);
    });

    root.querySelectorAll('.scb-style-card, .scb-mode-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(update, 0);
        setTimeout(update, 80);
      }, true);
    });

    update();
    setTimeout(update, 250);
  }

  function initAll(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV42Picot);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV42Picot(root);
  });
})();


/* v43 final picot fix: intercept before old handlers can overwrite */
(function(){
  function initV43PicotFinal(root){
    if(!root || root.dataset.scbV43PicotFinal === 'true') return;
    root.dataset.scbV43PicotFinal = 'true';

    var order = [];

    var colorMap = {
      'Soft Pink': '#DBC8C8',
      'Shimmery Black': '#191919',
      'Moss Green': '#61735A',
      'Matte Black': '#050505'
    };

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function outlineFor(hex){
      if(!hex || hex === 'transparent') return '#111111';
      var h = hex.replace('#','');
      if(h.length !== 6) return '#111111';
      var r = parseInt(h.slice(0,2),16);
      var g = parseInt(h.slice(2,4),16);
      var b = parseInt(h.slice(4,6),16);
      return ((0.2126*r + 0.7152*g + 0.0722*b) / 255) > 0.6 ? '#111111' : '#ffffff';
    }

    function isSimpleTop(){
      var top = q('.scb-style-card[data-style-kind="top"].is-active');
      var bottom = q('.scb-style-card[data-style-kind="bottom"].is-active');
      var modeBtn = q('.scb-mode-btn.is-active');
      var mode = modeBtn ? modeBtn.getAttribute('data-mode') : 'set';
      var topId = top ? top.getAttribute('data-style-id') : '';
      var bottomId = bottom ? bottom.getAttribute('data-style-id') : '';
      var hasTwo = (mode !== 'bottom' && topId === 'top_2_layer') || (mode !== 'top' && (bottomId === 'bottom_2_layer' || bottomId === 'bottom_2_layer_hipster' || bottomId === 'bottom_2_layer_cheeky'));
      var hasFour = (mode !== 'bottom' && topId === 'top_4_layer') || (mode !== 'top' && bottomId === 'bottom_4_layer');
      return hasTwo && !hasFour;
    }

    function apply(){
      if(isSimpleTop()) order = order.slice(0, 1);

      qa('[data-color-kind="picot"]').forEach(function(btn){
        var name = btn.getAttribute('data-color-name') || '';
        btn.classList.toggle('is-active', order.indexOf(name) !== -1);
      });

      var first = colorMap[order[0]] || 'transparent';
      var second = colorMap[order[1]] || first;

      root.style.setProperty('--scb-picot-color-1', first);
      root.style.setProperty('--scb-picot-color-2', second);
      root.style.setProperty('--scb-picot-outline-color-1', outlineFor(first));
      root.style.setProperty('--scb-picot-outline-color-2', outlineFor(second));

      scbSyncPicotInputs(root, order);

      var summary = q('[data-picot-summary]');
      if(summary) summary.textContent = order.length ? order.join(', ') : (isSimpleTop() ? 'Choose 1 color' : 'Choose 1 or 2');

      qa('.scb-optional-svg').forEach(function(svg){
        svg.classList.toggle('scb-show-picot', order.length > 0);
      });

      if(typeof root.scbRenderActualPicotPreview === 'function'){
        root.scbRenderActualPicotPreview();
      }
    }

    function handlePicotClick(event){
      var btn = event.target && event.target.closest ? event.target.closest('[data-color-kind="picot"]') : null;
      if(!btn || !root.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var name = btn.getAttribute('data-color-name') || '';
      if(!name) return;

      var index = order.indexOf(name);
      if(index !== -1){
        order.splice(index, 1);
      } else {
        if(isSimpleTop()){
          order = [name];
        } else {
          if(order.length >= 2) order.shift();
          order.push(name);
        }
      }

      apply();

      // Beat any delayed old controllers still scheduled elsewhere.
      [0, 30, 80, 160, 320, 700].forEach(function(ms){
        setTimeout(apply, ms);
      });
    }

    // Root capture runs before old target listeners.
    root.addEventListener('click', handlePicotClick, true);

    root.querySelectorAll('.scb-style-card, .scb-mode-btn').forEach(function(el){
      el.addEventListener('click', function(){
        setTimeout(apply, 0);
        setTimeout(apply, 150);
      }, true);
    });

    apply();
  }

  function initAll(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV43PicotFinal);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV43PicotFinal(root);
  });
})();


/* v49: render actual Picot.svg path preview, using v43 click-order input */
(function(){
  function initV49ActualPicotPreview(root){
    if(!root || root.dataset.scbV49ActualPicotPreview === 'true') return;
    root.dataset.scbV49ActualPicotPreview = 'true';

    var PICOT_SVG = `<svg viewBox="0 0 571.72 309.94" aria-hidden="true" focusable="false"><path d="M559.74,232.22c-1.47,1.36-1.12,4.35-4.17,4.13-2.11-.16-1.53-2.43-2.14-3.86-3.62-8.53-26.77-12.81-33.47-6.55-1.68,1.57-1.53,5.37-4.88,4.42-1.62-.46-.83-1.79-1.18-2.79-1.09-3.17-4.17-2.92-5.69-4.85-.79-1.01-.71-2.55-1.95-3.55-1.42-1.15-3.37-.91-5-1.5-.94-.34-1.57-1.46-2.81-1.69-1.25-.23-9.84-.67-10.86-.4-.33.09-5.41,2.61-6.04,2.96-1.84,1.02-6.48,5.1-8.06,4.94-1.38-.14-3.63-4.42-4.78-5.75-5.91-6.84-15.86-9.03-24.49-6.52-4.3,1.25-4.74,4.09-7.02,4.98-3.45,1.34-3.14-1.91-5-3.46-2.51-2.09-13.99-5.62-17.31-5.73-1.46-.05-2.79.57-4.43.5-1.49-.06-2.88-.94-3.91-.89-.86.04-4.34,2.22-5.08,2.86-1.58,1.36-1.86,2.91-2.98,4.03-2.8,2.8-3.21-2.23-5.25-3.8-.48-.37-5.83-3.71-6.17-3.83-.45-.17-8.72-2.06-9.28-2.11-1.09-.09-8.86-.15-9.49.04-.62.19-7.18,3.73-7.71,4.17-1.66,1.4-2.02,4.21-4.63,4.06-2.56-.14-1.79-2.51-2.9-3.91-.27-.34-2.5-1.79-3.08-2.16-8.08-5.09-20.58-6.68-28.84-1.3-2.79,1.82-2.54,4-3.63,4.87-3.06,2.44-3.76-2.44-4.69-3.91-1.64-2.61-7.37-5.05-10.41-5.59-3.73-.66-12.11-.85-15.89-.5-3.08.28-7.34,1.47-8.29,4.73l-1.18.17c-1.94-1.87-4.2-3.27-6.65-4.38-5.76-2.61-13.91-6.13-20.06-7.44-2.13-.45-5.72-.25-7.5-1-1.53-.64-8.83-6.03-10.59-7.41-.51-.4-1.85-1.53-1.95-2.04-.24-1.24,5-6.14,6.19-7.16,27.76-24.06,74.68-26.69,109.93-30.57,4.8-.53,10.25-2.09,15.07-2.43,21.75-1.55,44.84.06,66.53-.97,28.31-1.34,74.35-6.17,96.95-24.55,14.83-12.06,7.18-32.33,12.4-48.6.54-1.69,2.53-3.66,2.83-5.67.39-2.61.27-11.23.02-13.96-.6-6.6-2.66-8.91-5.92-14.08-1.39-2.2-2.32-5.22-4.53-6.97-.21-.17-4.57-2.03-4.9-2.11-1.43-.33-3.68.49-4.15.19-.58-.36-1.25-2.96-2.07-3.97-1.8-2.22-5.1-4.63-7.39-6.11-2.89-1.87-3.3-2.36-7.27-2.24-2.92.09-4.1,1.88-4.82,4.47-2,1.28-2.33-3.9-2.91-5.22-1.09-2.51-2.44-1.93-3.99-3.01-5.83-4.09-8.25-4.06-15.29-4.25-2.48-.07-4.67,1.53-5.98,3.56-1.17,1.82-.65,4.26-3.48,3.98-2.69-.27-2.75-2.84-4.27-4.27-2-1.89-9.13-5.77-11.77-5.77-.88,0-6.77.27-7.1.4-1.03.41-1.6,1.64-2.38,2.16-.87.57-1.93.44-2.82,1.18-1.52,1.27-1.51,5.23-4.19,5.81-1.08.15-.6-.21-.8-.72-1.64-4.17-1.13-2.57-4.41-4.59-4.71-2.89-2.03-1.15-6.25-1.7-.91-.12-1.44-1.03-3.03-1.06-2.37-.05-8.28,1.5-10.4,2.67-1.86,1.03-4.34,5.42-5.11,5.41-.34,0-3.21-2.2-3.48-2.55-.87-1.1-.57-2.57-2.08-3.42-1.06-.6-2.16-.44-3.21-.79-1.49-.5-6.42-2.5-7.73-2.53-.54-.01-7.81,1.34-8.24,1.53-.23.1-3.38,2.92-3.71,3.29-1.3,1.44-2.82,5.17-4.55,5.46-1.01.16-.63-.21-.86-.66-1.93-3.77-2.67-5.64-7.26-6.74-1.06-.25-2.24.03-3.28-.22-1.14-.27-1.65-1.38-3.08-1.42-.46-.01-8.25,1.21-8.66,1.37-.25.1-4.18,2.95-4.38,3.14-1.5,1.43-1.4,4.7-4.44,4.98-1.61-1.07-1.5-3.85-2.66-4.99-3.72-3.68-14.76-6.4-19.63-4.22-.52.23-1.11,1.22-1.82,1.68-.75.48-1.73.43-2.42,1.08-1.72,1.63-.36,5.26-3.46,5.45-3.84-6.26-6.46-10.39-14.58-10.48-1.68-.02-2.76.93-4.01.99-.94.04-1.78-.59-2.85-.4-1.13.2-1.99,1.5-3.01,2.03-2.57,1.32-3.09-.15-4.22,3.28-.41,1.23.24,2.73-1.38,3.61-2.55-1.2-2.98-5.16-4.57-6.43-3.48-2.79-5.48-2.59-9.41-3.09-.83-.11-1.29-.97-2.45-.96-.99,0-8.72.98-9.32,1.24-.22.09-3.37,2.91-3.52,3.12-1.37,1.84-.33,4.29-2.24,5.62-2.37-3.96-4.43-7.96-9.61-8.38-3.11-.26-7.18.73-9.92.86-1.52.07-2.71-.67-4.85-.35-.74.11-3.5,1.04-4.06,1.43-1.6,1.12-.8,3.69-3.05,3.46-1.03-3.28-4.13-2.89-5.96-4.07-1.27-.82-1.09-2.58-3.62-2.79-2.4-.2-3.97-1.07-4.91-1.11-.47-.02-8.82,1.03-9.26,1.21-.29.12-4.21,2.19-4.39,2.36-1.06.99-1.07,4.94-3.87,5.18-2.14-.23-1.4-3.05-2.98-4.33-.29-.23-5.71-2.2-6.26-2.29-4-.65-8.57-.43-12.55.52-.57.14-5.03,3.14-5.45,3.55-1.16,1.14-2.61,8.35-6.28,5.26-.8-.67-.89-1.79-1.51-2.48-.86-.96-5.81-3.19-7.09-3.44-1.22-.24-11.7.66-13.28,1.01-.47.1-4.24,3.47-4.57,3.93-.25.35-2.1,8.56-3.78,5.63-.57-.99-.75-3.03-1.78-4.14-4.77-5.17-22-1.33-26.19,3.76-1.66,2.02-.08,5.37-3.28,6.23l-3.27-3.74c-6.08-2.21-15.07-4.27-21.15-.7-.84.49-4.68,3.98-4.82,4.68-.19,1.01.49,3.87-.78,4.24-2.5.72-4.76-4.81-6.26-5.71-1.32-.8-5.25-2.35-6.72-2.32-2.1.04-12.73,1.54-14.25,2.29-.25.13-3.57,4.02-3.71,4.29-.97,1.8.55,4.63-2.12,4.85-.44.04-3.24-1.22-3.54-1.52-.6-.6-.46-1.88-1.66-2.59-.34-.2-7.25-1.71-7.72-1.71-2.09,0-6.8,1.09-9.02,1.41-1.84.27-3.4.02-4.94.55v57.62c6.19-1.14,12.34-2.56,18.55-3.56,12.88-2.08,25.95-3.21,38.85-5.15,66.11-9.94,131.93-24.76,199.04-21.91,43.6,1.85,86.85,3.37,130.54,3.46,13.33.03,26.58-.91,39.97-.47,19.68.64,39.92.88,59.28,4.72,3.52.7,23.07,5.69,23.94,8.59.13.43.04.82-.21,1.18l-9.58,11.47c-1.09.19-1.96-2.3-2.92-2.98-.99-.71-2.24-.69-3.23-1.27-.88-.51-1.52-1.88-2.4-2.14-.42-.12-8.03.38-8.77.53-2.04.42-11.07,5.91-12.69,7.56-1.11,1.13-3.28,5.17-4.42,5.35l-3.5-3.03c.62-3.05-5.63-7.84-8.04-7.96-1.42-.07-3,.92-4.49.99-1.4.06-2.55-.59-3.84-.43-1.66.2-2.34,1.54-3.24,1.81-.96.28-1.98-.02-3.13.37-.68.23-4.99,3.33-5.52,3.98-2.47,2.98-.14,8.04-5.37,5.88-1.24-.51-2.06-2.21-3.16-2.84-5.31-3-15.54-3.15-21.3-1.37-1.79.55-7.6,4.34-8.82,4.02-1.93-.94-1.94-3.66-2.91-5.13-.51-.77-6.24-3.98-7.3-4.2-4.16-.89-6.07-.69-9.92-.14-1.36.2-3.25-.28-4.39.11-.85.29-1.13,1.99-2.45,2.55-1.34.57-2.7.12-3.87.63-1.75.77-2.93,6.24-5.74,6.75-.69-.16-1.87-3.61-2.54-4.47-.89-1.14-7.49-4.3-9.11-4.43-4.14-.33-11.28.48-15.09,2.17-1.08.48-1.54,2.07-2.17,2.58-.85.68-2.54,1.07-3.32,1.94-1.44,1.61-.58,5.24-1.78,5.72-.49-1.54-2.11-1.34-3.21-2.28-1.07-.92-1.46-2.89-2.84-3.66-.36-.2-7.53-2.06-7.94-2.06-.59,0-7.3.97-7.89,1.12-.87.23-1.59,1.28-2.39,1.61-1.08.44-2.18.06-3.27.73-1.11.69-1.3,2.46-1.98,3.52-.42.65-1.24,1.1-1.66,1.84-1.04,1.86-.99,6.66-3.57,5.34-.46-3.79-1.96-3.37-4.36-4.55-2.06-1.02-2.47-2.48-5.78-1.51-.82.24-7.85,4.76-8.68,5.56-2.17,2.1-5.99,10.88-7.52,11.27-2.09.54-3.25-4-5.41-4.43-4.75-.93-9.53-.78-14.21.76-2.56.84-7.58,5.72-8.95,8.05-.67,1.14-.92,3.56-1.78,4.22-1.43,1.1-4.61.01-6.44.56-.26.08-3.79,2.99-4.13,3.37-3.41,3.77-4.74,9.35-5.68,14.19-4.91,2.93-6.92-.51-8.6,6.02-1.69,6.54,1.1,7.63,1.11,12.57,0,3.68-1.82,11.17-1.54,13.95.12,1.22,2.88,10.17,3.47,11.56,1.06,2.48,2.63,3.1,3.3,6.2,1.92,8.98,1.21,18.71,4.63,27.37,10,25.33,38.81,43.07,64.91,47.09,38.65,5.95,80.26,4.33,119.42,6.58,23.88,1.37,45.73,9.18,68.25,16.25l99.51,24.24v-46c-1.94.31-5.48-.95-5.46-3.25,0-1.04,1.29-2.61,1.43-4.06.33-3.27-1.96-8.52,4.03-8.19v-19.5c-3.34-.52-9.49.98-11.98,3.27ZM11.71,57.19c-2.2.29-5.06,2.4-6.99.5.01-.8,4.01-2.01,4.86-2.14.72-.11,1.47-.32,2.14.13l-.02,1.51ZM11.54,49.87c-1.43-.44-.26-1.73-.37-2.62-.34-2.7-2.66-4.09-1.35-6.46.43-.79,4.13-1.59,5.28-1.73.59-.07,1.19-.26,1.79-.06l.75.77c.22,2.78-.39,5.3,1.01,7.86-.28,1.52-5.64,2.7-7.11,2.24ZM20.03,55.91c-3-3.08,2.96-3.76,4.93-4.97l.76,4-5.69.97ZM36.78,51.63l-.06-1.69c2.91.35,5.62-2.36,7.49.75,0,.6-6.97,2.52-7.43.94ZM49.99,42.95c-.67,1.1-7.2,1.73-7.7.92.85-3.46-2.31-5.36-1.32-8.44.84-1.34,8.14-1.78,8.69-.92.6,1.52-.42,3.45-.37,4.7.05,1.23,1.58,2.3.7,3.73ZM56.48,45.45l1.24,3.49c-8.29,2.4-10-1.28-1.24-3.49ZM76.22,45.69c-.19.92-8.54,1.88-7.99-.49.68-.79,1.9-.97,2.88-1.12,1.22-.19,5.56-.5,5.11,1.6ZM82.22,37.94c-2.83.63-4.92,2.09-8,1.5,1.15-3.01-.07-5.42-1.99-7.75,2.39-2.33,5.97-1.94,9.01-1.51.69.42-.26,3.65,0,5,.18.96,1.25,1.63.98,2.77ZM82.95,44.47c-1.34-3.28,3.52-2.98,5.75-3.5l1.03,2.98c-1.45-.49-5.99,1.71-6.77.53ZM100.52,39.91c1.42-.5,4.82-1.62,6.1-.85.25.15.53,1.38,1.1,1.64,0,.78-9.04,2.85-7.19-.79ZM113.22,33.95l-7.51.5c.62-3.59-.71-5.43-2.5-8.24.39-1.63,9.22-2.3,10.3-.78-.96,3.12-.62,5.34-.29,8.52ZM113.73,39.19c1.73-2.68,6.85-4.07,6.99.25-2.41-.38-5.18,1.94-6.99-.25ZM138.72,36.18c-.24.8-7.1,1.7-7.77.79l-.22-1.52c1.52-.24,9.11-3.03,7.99.73ZM137.19,29.72c-.89-.61-.33-3.74-.49-5.01-.13-1.04-1.83-2.2-.35-3.65.24-.24,6.23-1.44,6.63-1.43,3.73.12,1.23,4.49,1.31,6.08.05,1.15,1.43,2.09.72,3.25-.51.68-6.64,1.31-7.82.75ZM146.35,35.85c-1.17.15-1.61-1.83-.82-2.45l5.66-.94c1.83,4.33-2.18,2.39-4.84,3.39ZM162.22,33.94c-1.43-1.39,4.42-3.83,5.87-2.37.51.51.65,1.65.63,2.37h-6.5ZM169.85,27.06c-2.37-1.01-1-2.07-1.33-3.62-.38-1.81-1.35-3.39-1.74-5.19.17-.7,1.96-1.4,2.68-1.54,1.27-.24,6.46-.03,6.99,1.21.5,1.16-1.7,5.88-.3,7.74l-.43.52c-2.09.8-3.59,1.86-5.88.88ZM183.47,32.94h-7.25c-1.48-1.46,5.12-3.98,6.02-3.29.58.44.4,2.46,1.98,2.3.14.18-.66.99-.75.99ZM192.72,29.95c2.56.37,5.62-1.85,7.49.75,0,.78-8.72,2.57-7.49-.75ZM199.46,24.45c-.54-.92-.08-2.5-.36-3.64-.56-2.29-2.89-4.24.9-4.83,2.98-.46,5.36.76,8.22.97-.44,3.12-2.38,5.01-1,8.49-1.85-.74-6.76.72-7.76-.99ZM205.72,30.94c-.21-2.53,7.26-2.34,7.49-1.24.44,2.08-6.23.99-7.49,1.24ZM230.57,17.04c1.03-.3,6.93-.33,7.43.37.52,1.51-.78,2.76-.82,4.29-.03,1.19,1.03,2.84.04,3.51l-7.29-.24c-.71-1.24.31-2.53.26-3.74-.06-1.4-2.06-3.46.38-4.18ZM223.72,30.94c-1.08-1.15,2.81-1.51,3.24-1.52,1.56-.05,2.78-.16,3.75,1.28.02,1.17-6.37.91-6.99.24ZM236.72,31.44c-.51-2.4,6.13-2.87,6.5-2.5v2.51s-6.5,0-6.5,0ZM253.72,30.45c1.77-.36,5.82-1.58,6.5.74-.28,1.38-5.91.65-6.5-.74ZM260.69,25.71l-.76-7.79c2.64-2.08,5.77-.99,8.79-.98-.05,3-2.45,5.39-1.5,8.5l-6.53.27ZM267.47,31.95c-1.19-2.83,4.12-1.81,5.74-3.5l.5,4-6.25-.49ZM291.7,17.69c1.82-1.74,7.17-.64,8.98.81-1.38,2.76-2.03,4.6-2.42,7.73l-7.53.21c-.04-1.08.79-1.66.97-2.77.28-1.77-.78-5.23,0-5.98ZM290.71,32.19c-.32,1.03-4.28.97-5.17.68-.82-.27-1.82-1.99-.51-2.35,1.28-.35,6.4-.63,5.67,1.67ZM302.48,33.43c-.97,0-5.2.37-5.25-.74,1.37-3.38,4.13-2.15,6.99-2.75-.83,1.78-.19,1.86.24,3.01.54,1.45-1.37.48-1.97.47ZM320.59,33.31c-.81.94-4.28.65-5.55.56-.92-.29-1.04-1.79-.84-2.61.3-1.28,9.72-1.82,6.4,2.05ZM321.43,26.46c-.24-.35,1.05-7.04.38-8.44,1.51-1.7,9.32-.03,9.4,1.17-2.4,2.24-1.46,4.87-2.68,7.3-1.54.65-6.04,1.47-7.09-.04ZM327.72,33.94c-.31-3.67,4.08-3.24,6.5-4.5-.61,2.96.38,2.43,1.26,3.48,2.12,2.53-6.9.77-7.75,1.02ZM351.72,34.21l-7.5-.77c-.16-3.7,4.51-2.34,6.92-2.41-.07,1.03,1.73,2.47.58,3.18ZM352.2,27.21l.03-8.77c3.3-.15,6.12-.52,9.29.97.74.96-.82,2.81-1.18,3.9-.26.78.12,2.06-.19,2.56-.75,1.23-6.4,2.2-7.94,1.35ZM358.72,33.94c.03-3.1,3.39-3.85,6-3.49-.88,1.7.19,2,.5,3.49h-6.5ZM381.9,34.32c-1.19-.07-6.47-.1-6.68-1.13.96-3.15,4.38-2.19,6.94-2.18.13,1.13,1.22,2.79-.26,3.32ZM383.3,26.87l.42-8.69c3.32-.47,5.81-.24,9,.27l-2.46,8.29c-2.52-.24-4.45.88-6.96.13ZM388.72,34.44c.04-1.91.66-3.82,2.8-4,1.49-.12,2.33.9,3.94-.51l.68.74c-1.09,1.7.32,2.26.58,3.77h-8ZM407.04,34.37c-1.07-.36-.94-1.93-.76-2.87,1.97-1.22,4.73.68,6.19-1.05,3.64,5.17-1.78,4.01-5.43,3.92ZM412.73,26.19c1.99-2.11,2.89-5.52,1.99-8.25.93.26,2.15-.85,2.74-.81.68.05,3.55,1.06,4.53,1.27,1.11.24,2.45-.39,3.22.79-.37,1.12-1.77,1.94-2.2,2.79-.7,1.38-.47,3.82-1.28,4.72-.96,1.07-9.02.62-9-.51ZM426.72,33.94h-8c.88-3.08,4.5-3.32,7.25-3.51,1.52-.1.45,2.71.75,3.51ZM444.41,33.91c-1.22-.74-7.7.02-7.68-1.21,1.83-2.43,5.67,0,8.49-.75l-.81,1.96ZM449.04,28.27c-.56-.03-1.06-.6-1.63-.68-.59-.09-2.89.94-2.48-.67.19-.72,1.32-1.64,1.56-2.46.63-2.16-.08-4.09,1.72-6.28,1.25-1.52,1.46-.03,2.33.12.69.11,1.41-.59,2.06-.24.13.07.07.83.45.9.82.15,2.36-.51,3.67.49.01,1.43-1.57,1.91-2.12,3.13-1.74,3.9.89,6.08-5.57,5.7ZM458.22,34.94l-7-1c-1.43-1.57,6.24-2.05,7-2.49v3.5ZM474.82,36.62c-.97-.08-6.09-.91-6.09-1.93l1.24-1.11c1.74,1.19,3.37.09,5.37.99,1.97.89,2.1,2.25-.52,2.04ZM476.78,28.78c2.72-2.02.46-4.38,1.56-6.72l4.68-.99.79,1.3c.55.34,2.65-1.1,2.93,1.32-1.66,2.33-2.45,4.9-2.75,7.77l-.56.42c-1.44-.43-7.34-.68-6.66-3.1ZM488.72,38.45c-1.29-.22-5.97-.21-6.49-1.26-.27-.99,1.19-1.11,1.79-1.19,1.55-.21,3.15.03,4.71-.05v2.5ZM499.72,41.44c-.24-3.94,4.35-.58,5.99.25.07,1.65-5.23-.63-5.99-.25ZM506.18,36.14c.26-2.51,2.25-3.36,1.04-6.2.66-.03,1.21-.1,1.85.16.11.04,1.8,1.25,1.88,1.34.9,1.03.57,3.83,0,4.98-.83,1.68-3.48.44-4.76-.28ZM513.72,84.45c-1.14,1.97.27,5.33-.07,6.63-.16.62-2.56,3.82-3.67,3.37l-1.19-7.15c.25-1.06,4.52-3.28,4.93-2.85ZM493.22,104.45c.47,2.04-5.69,2.81-6,2.49l.29-1.54,5.71-.95ZM486.94,91.48l.74,1.16c-2.5,1.52-1.44,6.6-2.07,7.7-.09.17-2.82,1.9-3.24,2-1.45.33-3.16,0-4.65.11l-1.46-8.95c3.4-1.63,7.06-1.61,10.68-2.02ZM478.71,107.69c-1.41,1.5-3.24,1.88-5.21,2.18l-1.28-2.93c2.1.9,4.64-1.01,6.49.75ZM459.71,110.2c.86,2.72-5.17,1.52-6.49,1.74-.87-2.83,6.04-3.19,6.49-1.74ZM451.7,95.48l-.21,9.46c-1.85,2.43-4.75.91-7.28,1.28l-.44-.59c1.14-3.41-1.44-5.28-2.03-8.15,3.25-1.02,6.41-3.48,9.96-1.99ZM438.22,110.94l7,.5-.22,1.52-.6.4-6.67.57.5-3ZM425.99,113.43c.28.28-.23,1.24-.4,1.4-1.07,1.03-1.95-.22-2.62-.21-.92.02-2.72,1.18-4.42.31l-.34-1.24c2.44-1.49,5.23-1.65,7.78-.26ZM409.08,99.55c.84-.26,7.71-1.19,8.15-.89,1.39.97-.36,2.71-.53,4-.28,2.07.67,3.86.32,5.81-2.5,1.1-5.25.82-7.73-.1-.11-1.56-.02-3.17-.57-4.68-.49-1.34-2.91-3.16.37-4.15ZM409.68,113.98l.03,1.46-5.67-.48-.32-2.52c2.21.36,3.88.6,5.96,1.54ZM390.72,115.44l-6.16.02-1.33-2.52c.39-.29,8.63-.38,7.5,2.49ZM372.44,98.93c.94-1.52,8-1.49,9.29-.74,1.92,1.11.22,6.13.09,8.01-.05.82.82,1.96.19,2.78-3.38,2.13-4.92.31-8.29-.54,1.2-2.11,1.04-3.71.25-5.99-.45-1.28-1.78-2.23-1.53-3.52ZM375.71,115.19c.07,1.14-2.22.33-2.66.4-1.15.18-2.26,1.33-4.26.28l-.57-2.43c1.11-.55,7.44.95,7.49,1.75ZM349.22,115.45c2.1-.24,4.93-1.08,6.5.99-2.16-.2-3.69.88-5.8.06-.68-.26-.86.17-.7-1.05ZM338.6,100.58c1.59-.65,2.91-.2,4.29-.31.4-.03.82-.63,1.17-.67.67-.08,1.23.21,1.83.43,2.04,1.32.8,7.71,2.3,10.09-.46,1.64-8.03,2.84-8.86-.03-.42-1.46.18-3.22-.23-4.77-.39-1.48-3.69-3.43-.5-4.74ZM339.69,116.48l.03,1.46c-2.4-.68-5.22,1.69-5.49-2.5l5.47,1.04ZM319.71,117.67c2.37-.6,1.5,2.57.2,2.74-.64.08-1.16-.98-1.84-.88-.83.12-2.59,1.69-4.35.91v-1.99c2.41.43,3.95-.26,5.99-.78ZM302.44,106.43c.88-1.33,8.06-3.63,9.27-2.47.5,1.91-.6,4.05-.53,5.74.06,1.47,1.41,2.63,1,4.21-1.89.6-7.12,2.29-7.86-.31-.34-1.2.15-2.61-.2-3.8-.33-1.13-2.69-1.82-1.68-3.37ZM305.72,119.95c.09.72,0,1.21-.46,1.79-.78.98-5.95.92-6.53-1.04-.02-1.25,5.88-.61,6.99-.75ZM287.72,123.45c.32,1.17-1.13,1.49-1.91,1.83-.73.31-4.32,1.73-4.59.41-.33-1.64,5.41-2.16,6.49-2.24ZM280.22,111.95c-1.05,3.59-1.02,5.36-.04,8.95-6.19,3.16-7,.66-7.35-5.36,2.48-1.44,4.06-4.13,7.4-3.6ZM273.72,127.45l-.29,1.54-5.21.95v-1.49s5.5-1,5.5-1ZM257.22,134.7c.22,1.2-3.62,2.62-3.99,2.24-1-1.76,3.73-3.68,3.99-2.24ZM252.72,122.45c-1.43,4.61.52,11.93-6.53,11.29l-1.93-6.74c2.72-1.68,4.59-4.81,8.46-4.55ZM246.72,140.2c.22,1.12-3.21,2-3.82,2.69l-1.18-1.94c.85.16,4.7-2.26,5-.75ZM262.73,219.7c-1.39.82-4.86.33-5.64-1.37-.24-.53-.86-5.94-.83-6.67.04-.76.61-1.43,1.32-1.63,1.55-.45,5.67.87,6.38,2.43.54,1.17-.2,6.64-1.24,7.25ZM267.92,229.9c-2.59.81-2.79-2.56-1.43-2.95,1.67-.48,3.24,2.39,1.43,2.95ZM285.71,233.19l.27-1.26,4.24.51v1.49c-.85.08-4.26.06-4.51-.75ZM300.23,227.7c-1.39.83-7.64-.5-8.27-1.75-.18-2.48-1.32-9.1,1.62-9.92.32-.09,5.75.32,6.37.43,4.04.73,1.41,10.56.27,11.25ZM302.46,234.94c-.47-.34.27-.85.57-.93,5.62-1.56,3.83,4.44-.57.93ZM330.72,226.69c-.01-2.27-2.3-4.99.72-6.78,1.84-1.1,9.42-.56,10.43,1.68.67,1.49-.79,4.48-1.11,6.15-.24,1.27.46,2.85-.79,3.71h-8.5c-2.14-.6-.74-3.57-.75-4.75ZM346.22,238.69c-.42,2.03-5.31-.32-6.5-.25-.83-.62.06-.91.74-1,.96-.12,6.11-.49,5.76,1.24ZM367.72,241.44c-1.34.11-4.34.13-5-1.25-.48-1.01.81-.71,1.24-.74,1.24-.09,2.52.05,3.76,0v1.99ZM378.24,234.72c-1.58.48-6.85.83-7.42-1.12-.23-.79-.75-8.55-.59-9.39.28-1.42,1.54-1.9,2.85-2.14,1.94-.35,8.45.21,9.05,2.23.53,1.78-1.26,4.24-1.8,6.01-.51,1.69.59,3.59-2.09,4.41ZM381.05,240.03c1.95-.61,4.04-.05,5.16,1.67-1.72,2.71-8.91-.49-5.16-1.67ZM418.62,235.84c-.53.76-5.09.74-6.16.62-4.83-.57-1.79-3.2-1.71-5.77.07-2.45-2.09-5.51,2.25-6.2,1.42-.22,7.78.37,8.5,1.45,1.37,2.05-3.09,7.39-2.87,9.92ZM441.22,247.19c-.21-1.93,3.75-1.11,4-.74,1.32,1.99-3,2.75-4,.74ZM448.3,240.61c-.15-.44.36-8.58.53-9.31.27-1.2,1.07-1.97,2.25-2.25,2.04-.48,8.41.59,9.06,2.74.36,1.21-.05,2.29-.39,3.43-.61,2.02-1.95,5.78-3.37,7.12-1.56.47-7.5-.07-8.08-1.73ZM460.62,249.04c1.32-.04,1.83.7,2.56,1.73-1.47,4.24-9.28-1.54-2.56-1.73ZM484.22,255.94c-1.68.02-4.45.4-4.99-1.74.27-1.33,5.52-.22,4.99,1.74ZM486.84,246.29c.08-.54.98-1.4,1.18-2.31.41-1.94.45-6.4,1.84-7.91,1.69-1.84,4.82-.59,6.71.28,6.53,3.02,1.79,4.11.9,7.57-.9,3.5,1.26,5.67-4,5.54-1.78-.04-7.01-.61-6.62-3.18ZM501.51,258.48c-1.59,1.23-5.05-.37-6.79-1.05.28-3.09,7.51-3.06,7.51-.24l-.73,1.29ZM516.72,259.95l7.45.54c1.44,5.24-9.04.82-7.45-.54ZM528.19,250.67c.3-2.58-.72-7.53,2.88-8.62,1.57-.47,8.16,1.44,8.58,2.73.72,2.19-2.17,5.33-3.05,7.3-.51,1.14-.36,3.94-1.72,4.31-.28.08-5.22-.43-5.81-.56-3.57-.75-1.08-3.47-.89-5.17ZM535.34,262.56c1.63-1.61,5.49-.94,6.17,1.88,1.16,4.8-9.34,1.26-6.17-1.88ZM563.67,269.6c-.47,1.86-4.55,1.55-5.97,1.12-1.8-.55-2.97-3.1-1.15-3.7,1.69-.55,7.78-.04,7.12,2.58Z"></path><path d="M571.72,248.44v15.5c-1.94.31-5.48-.95-5.46-3.25,0-1.04,1.29-2.61,1.43-4.06.33-3.27-1.96-8.52,4.03-8.19Z"></path><path d="M489.85,236.07c1.69-1.84,4.82-.59,6.71.28,6.53,3.02,1.79,4.11.9,7.57s1.26,5.67-4,5.54c-1.78-.04-7.01-.61-6.62-3.18.08-.54.98-1.4,1.18-2.31.41-1.94.45-6.4,1.84-7.91Z"></path><path d="M451.07,229.05c2.05-.48,8.41.59,9.06,2.74.36,1.21-.05,2.29-.39,3.43-.61,2.02-1.95,5.78-3.37,7.12-1.56.47-7.5-.07-8.08-1.73-.15-.44.36-8.58.53-9.31.27-1.2,1.07-1.97,2.25-2.25Z"></path><path d="M531.07,242.05c1.57-.47,8.16,1.44,8.58,2.73.72,2.19-2.17,5.33-3.05,7.3-.51,1.14-.36,3.94-1.72,4.31-.28.08-5.22-.43-5.81-.56-3.57-.75-1.08-3.47-.89-5.17.3-2.58-.72-7.53,2.88-8.62Z"></path><path d="M373.09,222.06c1.94-.35,8.45.21,9.05,2.23.53,1.78-1.26,4.24-1.8,6.01s.59,3.59-2.09,4.41c-1.58.48-6.85.83-7.42-1.12-.23-.79-.75-8.55-.59-9.39.28-1.42,1.54-1.9,2.85-2.14Z"></path><path d="M331.47,231.44c-2.14-.6-.74-3.57-.75-4.75-.01-2.27-2.3-4.99.72-6.78,1.84-1.1,9.42-.56,10.43,1.68.67,1.49-.79,4.48-1.11,6.15-.24,1.27.46,2.85-.79,3.71h-8.5Z"></path><path d="M418.62,235.84c-.53.76-5.09.74-6.16.62-4.83-.57-1.79-3.2-1.71-5.77s-2.09-5.51,2.25-6.2c1.42-.22,7.78.37,8.5,1.45,1.37,2.05-3.09,7.39-2.87,9.92Z"></path><path d="M293.59,216.03c.32-.09,5.75.32,6.37.43,4.04.73,1.41,10.56.27,11.25-1.39.83-7.64-.5-8.27-1.75-.18-2.48-1.32-9.1,1.62-9.92Z"></path><path d="M344.05,99.6c.67-.08,1.23.21,1.83.43,2.04,1.32.8,7.71,2.3,10.09-.46,1.64-8.03,2.84-8.86-.03-.42-1.46.18-3.22-.23-4.77s-3.69-3.43-.5-4.74c1.59-.65,2.91-.2,4.29-.31.4-.03.82-.63,1.17-.67Z"></path><path d="M373.72,108.44c1.2-2.11,1.04-3.71.25-5.99-.45-1.28-1.78-2.23-1.53-3.52.94-1.52,8-1.49,9.29-.74,1.92,1.11.22,6.13.09,8.01-.05.82.82,1.96.19,2.78-3.38,2.13-4.92.31-8.29-.54Z"></path><path d="M485.61,100.34c-.09.17-2.82,1.9-3.24,2-1.45.33-3.16,0-4.65.11l-1.46-8.95c3.4-1.63,7.06-1.61,10.68-2.02l.74,1.16c-2.5,1.52-1.44,6.6-2.07,7.7Z"></path><path d="M451.7,95.48l-.21,9.46c-1.85,2.43-4.75.91-7.28,1.28l-.44-.59c1.14-3.41-1.44-5.28-2.03-8.15,3.25-1.02,6.41-3.48,9.96-1.99Z"></path><path d="M409.28,108.38c-.11-1.56-.02-3.17-.57-4.68-.49-1.34-2.91-3.16.37-4.15.84-.26,7.71-1.19,8.15-.89,1.39.97-.36,2.71-.53,4-.28,2.07.67,3.86.32,5.81-2.5,1.1-5.25.82-7.73-.1Z"></path><path d="M311.71,103.95c.5,1.91-.6,4.05-.53,5.74.06,1.47,1.41,2.63,1,4.21-1.89.6-7.12,2.29-7.86-.31-.34-1.2.15-2.61-.2-3.8-.33-1.13-2.69-1.82-1.68-3.37.88-1.33,8.06-3.63,9.27-2.47Z"></path><path d="M169.46,16.7c1.27-.24,6.46-.03,6.99,1.21.5,1.16-1.7,5.88-.3,7.74l-.43.52c-2.09.8-3.59,1.86-5.88.88s-1-2.07-1.33-3.62c-.38-1.81-1.35-3.39-1.74-5.19.17-.7,1.96-1.4,2.68-1.54Z"></path><path d="M414.72,17.95c.93.26,2.15-.85,2.74-.81.68.05,3.55,1.06,4.53,1.27,1.11.24,2.45-.39,3.22.79-.37,1.12-1.77,1.94-2.2,2.79-.7,1.38-.47,3.82-1.28,4.72-.96,1.07-9.02.62-9-.51,1.99-2.11,2.89-5.52,1.99-8.25Z"></path><path d="M452.6,18.06c.13.07.07.83.45.9.82.15,2.36-.51,3.67.49.01,1.43-1.57,1.91-2.12,3.13-1.74,3.9.89,6.08-5.57,5.7-.56-.03-1.06-.6-1.63-.68-.59-.09-2.89.94-2.48-.67.19-.72,1.32-1.64,1.56-2.46.63-2.16-.08-4.09,1.72-6.28,1.25-1.52,1.46-.03,2.33.12.69.11,1.41-.59,2.06-.24Z"></path><path d="M49.65,34.52c.6,1.52-.42,3.45-.37,4.7s1.58,2.3.7,3.73c-.67,1.1-7.2,1.73-7.7.92.85-3.46-2.31-5.36-1.32-8.44.84-1.34,8.14-1.78,8.69-.92Z"></path><path d="M136.35,21.06c.24-.24,6.23-1.44,6.63-1.43,3.73.12,1.23,4.49,1.31,6.08.05,1.15,1.43,2.09.72,3.25-.51.68-6.64,1.31-7.82.75-.89-.61-.33-3.74-.49-5.01-.13-1.04-1.83-2.2-.35-3.65Z"></path><path d="M113.22,33.95l-7.51.5c.62-3.59-.71-5.43-2.5-8.24.39-1.63,9.22-2.3,10.3-.78-.96,3.12-.62,5.34-.29,8.52Z"></path><path d="M208.22,16.95c-.44,3.12-2.38,5.01-1,8.49-1.85-.74-6.76.72-7.76-.99-.54-.92-.08-2.5-.36-3.64-.56-2.29-2.89-4.24.9-4.83,2.98-.46,5.36.76,8.22.97Z"></path><path d="M15.1,39.06c.59-.07,1.19-.26,1.79-.06l.75.77c.22,2.78-.39,5.3,1.01,7.86-.28,1.52-5.64,2.7-7.11,2.24s-.26-1.73-.37-2.62c-.34-2.7-2.66-4.09-1.35-6.46.43-.79,4.13-1.59,5.28-1.73Z"></path><path d="M321.81,18.02c1.51-1.7,9.32-.03,9.4,1.17-2.4,2.24-1.46,4.87-2.68,7.3-1.54.65-6.04,1.47-7.09-.04-.24-.35,1.05-7.04.38-8.44Z"></path><path d="M360.14,25.86c-.75,1.23-6.4,2.2-7.94,1.35l.03-8.77c3.3-.15,6.12-.52,9.29.97.74.96-.82,2.81-1.18,3.9-.26.78.12,2.06-.19,2.56Z"></path><path d="M300.68,18.5c-1.38,2.76-2.03,4.6-2.42,7.73l-7.53.21c-.04-1.08.79-1.66.97-2.77.28-1.77-.78-5.23,0-5.98,1.82-1.74,7.17-.64,8.98.81Z"></path><path d="M483.81,22.38c.55.34,2.65-1.1,2.93,1.32-1.66,2.33-2.45,4.9-2.75,7.77l-.56.42c-1.44-.43-7.34-.68-6.66-3.1,2.72-2.02.46-4.38,1.56-6.72l4.68-.99.79,1.3Z"></path><path d="M392.72,18.45l-2.46,8.29c-2.52-.24-4.45.88-6.96.13l.42-8.69c3.32-.47,5.81-.24,9,.27Z"></path><path d="M82.22,37.94c-2.83.63-4.92,2.09-8,1.5,1.15-3.01-.07-5.42-1.99-7.75,2.39-2.33,5.97-1.94,9.01-1.51.69.42-.26,3.65,0,5,.18.96,1.25,1.63.98,2.77Z"></path><path d="M257.58,210.02c1.55-.45,5.67.87,6.38,2.43.54,1.17-.2,6.64-1.24,7.25-1.39.82-4.86.33-5.64-1.37-.24-.53-.86-5.94-.83-6.67.04-.76.61-1.43,1.32-1.63Z"></path><path d="M230.57,17.04c1.03-.3,6.93-.33,7.43.37.52,1.51-.78,2.76-.82,4.29-.03,1.19,1.03,2.84.04,3.51l-7.29-.24c-.71-1.24.31-2.53.26-3.74-.06-1.4-2.06-3.46.38-4.18Z"></path><path d="M268.72,16.94c-.05,3-2.45,5.39-1.5,8.5l-6.53.27-.76-7.79c2.64-2.08,5.77-.99,8.79-.98Z"></path><path d="M252.72,122.45c-1.43,4.61.52,11.93-6.53,11.29l-1.93-6.74c2.72-1.68,4.59-4.81,8.46-4.55Z"></path><path d="M280.22,111.95c-1.05,3.59-1.02,5.36-.04,8.95-6.19,3.16-7,.66-7.35-5.36,2.48-1.44,4.06-4.13,7.4-3.6Z"></path><path d="M513.72,84.45c-1.14,1.97.27,5.33-.07,6.63-.16.62-2.56,3.82-3.67,3.37l-1.19-7.15c.25-1.06,4.52-3.28,4.93-2.85Z"></path><path d="M509.07,30.11c.11.04,1.8,1.25,1.88,1.34.9,1.03.57,3.83,0,4.98-.83,1.68-3.48.44-4.76-.28.26-2.51,2.25-3.36,1.04-6.2.66-.03,1.21-.1,1.85.16Z"></path><path d="M396.72,34.44h-8c.04-1.91.66-3.82,2.8-4,1.49-.12,2.33.9,3.94-.51l.68.74c-1.09,1.7.32,2.26.58,3.77Z"></path><path d="M556.54,267.02c1.69-.55,7.78-.04,7.12,2.58-.47,1.86-4.55,1.55-5.97,1.12-1.8-.55-2.97-3.1-1.15-3.7Z"></path><path d="M535.34,262.56c1.63-1.61,5.49-.94,6.17,1.88,1.16,4.8-9.34,1.26-6.17-1.88Z"></path><path d="M334.22,29.45c-.61,2.96.38,2.43,1.26,3.48,2.12,2.53-6.9.77-7.75,1.02-.31-3.67,4.08-3.24,6.5-4.5Z"></path><path d="M406.28,31.51c1.97-1.22,4.73.68,6.19-1.05,3.64,5.17-1.78,4.01-5.43,3.92-1.07-.36-.94-1.93-.76-2.87Z"></path><path d="M320.59,33.31c-.81.94-4.28.65-5.55.56-.92-.29-1.04-1.79-.84-2.61.3-1.28,9.72-1.82,6.4,2.05Z"></path><path d="M418.72,33.94c.88-3.08,4.5-3.32,7.25-3.51,1.52-.1.45,2.71.75,3.51h-8Z"></path><path d="M351.14,31.02c-.07,1.03,1.73,2.47.58,3.18l-7.5-.77c-.16-3.7,4.51-2.34,6.92-2.41Z"></path><path d="M494.72,257.43c.28-3.09,7.51-3.06,7.51-.24l-.73,1.29c-1.59,1.23-5.05-.37-6.79-1.05Z"></path><path d="M382.16,31c.13,1.13,1.22,2.79-.26,3.32-1.19-.07-6.47-.1-6.68-1.13.96-3.15,4.38-2.19,6.94-2.18Z"></path><path d="M25.72,54.94l-5.69.97c-3-3.08,2.96-3.76,4.93-4.97l.76,4Z"></path><path d="M304.22,29.95c-.83,1.78-.19,1.86.24,3.01.54,1.45-1.37.48-1.97.47-.97,0-5.2.37-5.25-.74,1.37-3.38,4.13-2.15,6.99-2.75Z"></path><path d="M130.72,35.45c1.52-.24,9.11-3.03,7.99.73-.24.8-7.1,1.7-7.77.79l-.22-1.52Z"></path><path d="M57.72,48.94c-8.29,2.4-10-1.28-1.24-3.49l1.24,3.49Z"></path><path d="M176.22,32.94c-1.48-1.46,5.12-3.98,6.02-3.29.58.44.4,2.46,1.98,2.3.14.18-.66.99-.75.99h-7.25Z"></path><path d="M88.69,40.96l1.03,2.98c-1.45-.49-5.99,1.71-6.77.53-1.34-3.28,3.52-2.98,5.75-3.5Z"></path><path d="M364.72,30.45c-.88,1.7.19,2,.5,3.49h-6.5c.03-3.09,3.39-3.85,6-3.49Z"></path><path d="M524.17,260.49c1.44,5.24-9.04.82-7.45-.54l7.45.54Z"></path><path d="M71.1,44.08c1.22-.19,5.56-.5,5.11,1.6-.19.93-8.54,1.88-7.99-.49.68-.79,1.9-.97,2.88-1.12Z"></path><path d="M106.61,39.06c.25.15.53,1.38,1.1,1.64,0,.78-9.04,2.85-7.19-.79,1.42-.5,4.82-1.62,6.1-.85Z"></path><path d="M151.19,32.46c1.83,4.33-2.18,2.39-4.84,3.39-1.17.15-1.61-1.83-.82-2.45l5.66-.94Z"></path><path d="M425.6,114.83c-1.07,1.03-1.95-.22-2.62-.21-.92.02-2.72,1.18-4.42.31l-.34-1.24c2.44-1.5,5.23-1.65,7.78-.26.28.28-.23,1.24-.4,1.4Z"></path><path d="M120.72,39.44c-2.41-.38-5.18,1.94-6.99-.25,1.73-2.68,6.85-4.07,6.99.25Z"></path><path d="M36.72,49.95c2.91.35,5.62-2.36,7.49.75,0,.6-6.97,2.52-7.43.94l-.06-1.69Z"></path><path d="M273.72,32.44l-6.25-.49c-1.19-2.83,4.12-1.81,5.74-3.5l.5,4Z"></path><path d="M458.22,31.44v3.5s-7-1-7-1c-1.43-1.57,6.24-2.05,7-2.49Z"></path><path d="M390.72,115.44l-6.16.02-1.33-2.52c.39-.29,8.63-.38,7.5,2.49Z"></path><path d="M168.09,31.57c.51.51.65,1.65.63,2.37h-6.5c-1.43-1.39,4.42-3.83,5.87-2.37Z"></path><path d="M469.97,33.59c1.74,1.19,3.37.09,5.37.99s2.1,2.25-.52,2.04c-.97-.08-6.09-.91-6.09-1.93l1.24-1.11Z"></path><path d="M453.22,111.94c-.87-2.83,6.04-3.19,6.49-1.74.86,2.72-5.17,1.52-6.49,1.74Z"></path><path d="M368.79,115.87l-.57-2.43c1.11-.55,7.44.95,7.49,1.75.07,1.14-2.22.33-2.66.4-1.15.18-2.26,1.33-4.26.28Z"></path><path d="M313.72,120.44v-1.99c2.41.43,3.95-.26,5.99-.78,2.37-.6,1.5,2.57.2,2.74-.64.08-1.16-.98-1.84-.88-.83.12-2.59,1.69-4.35.91Z"></path><path d="M285.04,30.51c1.28-.35,6.4-.63,5.67,1.67-.32,1.03-4.28.97-5.17.68-.82-.27-1.82-1.99-.51-2.35Z"></path><path d="M305.72,119.95c.09.72,0,1.21-.46,1.79-.78.98-5.95.92-6.53-1.04-.02-1.25,5.88-.61,6.99-.75Z"></path><path d="M192.72,29.95c2.56.37,5.62-1.85,7.49.75,0,.78-8.72,2.57-7.49-.75Z"></path><path d="M243.22,28.94v2.51s-6.5,0-6.5,0c-.51-2.4,6.13-2.87,6.5-2.5Z"></path><path d="M445.22,31.95l-.81,1.96c-1.22-.74-7.7.02-7.68-1.21,1.83-2.43,5.67,0,8.49-.75Z"></path><path d="M9.59,55.55c.72-.11,1.47-.32,2.14.13l-.02,1.51c-2.2.29-5.06,2.4-6.99.5.01-.8,4.01-2.01,4.86-2.14Z"></path><path d="M488.72,35.94v2.5c-1.29-.22-5.98-.21-6.5-1.26-.27-.99,1.19-1.11,1.79-1.19,1.55-.21,3.15.03,4.71-.05Z"></path><path d="M472.22,106.95c2.1.9,4.64-1.01,6.49.75-1.41,1.5-3.24,1.88-5.21,2.18l-1.28-2.93Z"></path><path d="M381.05,240.03c1.95-.61,4.04-.05,5.16,1.67-1.72,2.71-8.91-.49-5.16-1.67Z"></path><path d="M460.62,249.04c1.32-.04,1.83.7,2.56,1.73-1.47,4.24-9.28-1.54-2.56-1.73Z"></path><path d="M205.72,30.94c-.21-2.53,7.26-2.34,7.49-1.24.44,2.08-6.23.99-7.49,1.24Z"></path><path d="M409.68,113.98l.03,1.46-5.67-.48-.32-2.52c2.21.36,3.88.6,5.96,1.54Z"></path><path d="M223.72,30.94c-1.08-1.15,2.81-1.51,3.24-1.52,1.56-.05,2.78-.16,3.75,1.28.02,1.17-6.37.91-6.99.24Z"></path><path d="M339.69,116.48l.03,1.46c-2.4-.68-5.22,1.69-5.49-2.5l5.47,1.04Z"></path><path d="M253.72,30.45c1.77-.36,5.82-1.58,6.5.74-.28,1.38-5.91.65-6.5-.74Z"></path><path d="M287.72,123.45c.32,1.17-1.13,1.49-1.91,1.83-.73.31-4.32,1.73-4.59.41-.33-1.64,5.41-2.16,6.49-2.24Z"></path><path d="M339.72,238.44c-.83-.62.06-.91.74-1,.96-.12,6.11-.49,5.76,1.24-.42,2.03-5.31-.32-6.5-.25Z"></path><path d="M493.22,104.45c.47,2.04-5.69,2.81-6,2.49l.29-1.54,5.71-.95Z"></path><path d="M499.72,41.44c-.24-3.94,4.35-.58,5.99.25.07,1.65-5.23-.63-5.99-.25Z"></path><path d="M241.72,140.95c.85.16,4.7-2.26,5-.75.22,1.12-3.21,2-3.82,2.69l-1.18-1.94Z"></path><path d="M367.72,239.45v1.99c-1.34.11-4.34.13-5-1.25-.48-1.01.81-.71,1.24-.74,1.24-.09,2.52.05,3.76,0Z"></path><path d="M484.22,255.94c-1.68.02-4.45.4-4.99-1.74.27-1.33,5.52-.22,4.99,1.74Z"></path><path d="M355.72,116.44c-2.16-.2-3.69.88-5.8.06-.68-.26-.86.17-.7-1.05,2.1-.24,4.93-1.08,6.5.99Z"></path><path d="M445.22,246.45c1.32,1.99-3,2.75-4,.74-.21-1.93,3.75-1.11,4-.74Z"></path><path d="M266.49,226.95c1.67-.48,3.24,2.39,1.43,2.95-2.59.81-2.79-2.56-1.43-2.95Z"></path><path d="M290.22,232.45v1.49c-.85.08-4.26.06-4.51-.75l.27-1.26,4.24.51Z"></path><path d="M303.04,234.01c5.62-1.56,3.83,4.44-.57.93-.47-.34.27-.85.57-.93Z"></path><path d="M253.22,136.94c-1-1.76,3.73-3.68,3.99-2.24.22,1.2-3.62,2.62-3.99,2.24Z"></path></svg>`;

    function selectedPicotNames(){
      var input = root.querySelector('[data-input-picot-colors]');
      if(input && input.value.trim()){
        return input.value.split(',').map(function(x){ return x.trim(); }).filter(Boolean).slice(0,2);
      }
      return Array.prototype.slice.call(root.querySelectorAll('[data-color-kind="picot"].is-active'))
        .map(function(btn){ return btn.getAttribute('data-color-name') || ''; })
        .filter(Boolean)
        .slice(0,2);
    }

    function picotColorMap(){
      var map = {};
      Array.prototype.slice.call(root.querySelectorAll('[data-color-kind="picot"]')).forEach(function(btn){
        var name = btn.getAttribute('data-color-name') || '';
        var value = btn.getAttribute('data-color-value') || '';
        if(name && value) map[name] = value;
      });
      return map;
    }

    function escapeAttr(value){
      return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    }

    function render(){
      var box = root.querySelector('.scb-picot-reference');
      if(!box) return;

      var names = selectedPicotNames();
      if(!names.length){
        box.innerHTML = '';
        return;
      }

      var colors = picotColorMap();
      box.innerHTML = names.map(function(name){
        var color = colors[name] || '#111111';
        return '<span class="scb-picot-actual-preview" data-color-name="' + escapeAttr(name) + '" style="--picot-preview-color:' + escapeAttr(color) + '">' + PICOT_SVG + '</span>';
      }).join('');
    }

    root.scbRenderActualPicotPreview = render;

    root.querySelectorAll('[data-color-kind="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        [0, 60, 140, 280, 600, 1000].forEach(function(ms){ setTimeout(render, ms); });
      }, true);
    });

    root.querySelectorAll('[data-toggle-step="picot"], [data-complete-step="picot"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        [0, 120, 360].forEach(function(ms){ setTimeout(render, ms); });
      }, true);
    });

    render();
    setTimeout(render, 300);
    setTimeout(render, 1000);
  }

  function initAllV49(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV49ActualPicotPreview);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV49);
  else initAllV49();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV49ActualPicotPreview(root);
  });
})();

/* Desktop wording: selected titles only after option drawers collapse. */
(function(){
  function initSelectedStepTitles(root){
    if(!root || root.dataset.scbSelectedStepTitles === 'true') return;
    root.dataset.scbSelectedStepTitles = 'true';

    var labels = {
      picot: {open:'Choose picot elastic color', closed:'Picot Color Selected'},
      lace: {open:'Choose lace trim color', closed:'Lace Color Selected'}
    };

    function sync(){
      Object.keys(labels).forEach(function(name){
        var section = root.querySelector('[data-step-section="'+name+'"]');
        var title = section ? section.querySelector('.scb-step-summary strong') : null;
        if(!title) return;
        title.textContent = section.classList.contains('is-collapsed') ? labels[name].closed : labels[name].open;
      });
    }

    Object.keys(labels).forEach(function(name){
      var section = root.querySelector('[data-step-section="'+name+'"]');
      if(section && window.MutationObserver){
        new MutationObserver(sync).observe(section, {attributes:true, attributeFilter:['class']});
      }
    });

    root.querySelectorAll('[data-toggle-step], [data-complete-step]').forEach(function(btn){
      btn.addEventListener('click', function(){ [0, 80, 180].forEach(function(ms){ setTimeout(sync, ms); }); }, true);
    });

    sync();
    setTimeout(sync, 300);
  }

  function initAllSelectedStepTitles(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initSelectedStepTitles);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllSelectedStepTitles);
  else initAllSelectedStepTitles();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initSelectedStepTitles(root);
  });
})();

/* Mobile flow helper: keep the newly opened step below the sticky preview. */
(function(){
  function initMobileStepScroll(root){
    if(!root || root.dataset.scbMobileStepScroll === 'true') return;
    root.dataset.scbMobileStepScroll = 'true';

    function isMobile(){
      return window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
    }

    function stickyOffset(){
      var sticky = root.querySelector('.scb-stage-card');
      return sticky ? sticky.getBoundingClientRect().height + 10 : 0;
    }

    function activeStep(){
      var styleDrawer = root.querySelector('[data-style-drawer][open]');
      if(styleDrawer) return styleDrawer;
      var openOption = root.querySelector('[data-step-section]:not(.is-collapsed)');
      if(openOption) return openOption;
      if(!root.classList.contains('scb-fabric-collapsed')){
        var fabric = root.querySelector('.scb-fabric-head');
        if(fabric) return fabric;
      }
      return null;
    }

    function scrollToActiveStep(){
      if(!isMobile()) return;
      var target = activeStep();
      if(!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      window.scrollTo({top: Math.max(0, top), behavior: 'smooth'});
    }

    root.addEventListener('click', function(event){
      var trigger = event.target && event.target.closest ? event.target.closest('[data-complete-step], [data-toggle-step], [data-reopen-fabrics], .scb-style-card, .scb-mode-btn') : null;
      if(!trigger || !root.contains(trigger)) return;
      setTimeout(scrollToActiveStep, 140);
      setTimeout(scrollToActiveStep, 360);
    });
  }

  function initAllMobileStepScroll(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initMobileStepScroll);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllMobileStepScroll);
  else initAllMobileStepScroll();

document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initMobileStepScroll(root);
  });
})();

/* Mobile wizard: one selection screen at a time while the mockup stays sticky. */
(function(){
  function initMobileWizard(root){
    if(!root || root.dataset.scbMobileWizard === 'true') return;
    root.dataset.scbMobileWizard = 'true';

    var mq = window.matchMedia ? window.matchMedia('(max-width: 820px)') : null;
    var steps = [
      {id:'style', title:'Style'},
      {id:'size', title:'Size'},
      {id:'fabric', title:'Fabrics'},
      {id:'bow', title:'Bows'},
      {id:'picot', title:'Picot'},
      {id:'sequins', title:'Sequins'},
      {id:'lace', title:'Lace'},
      {id:'strap', title:'Strap Ends'},
      {id:'cart', title:'Order Note'}
    ];
    var current = 'style';
    var renderTimer = null;

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function isMobile(){ return mq ? mq.matches : window.innerWidth <= 820; }

    function createNav(){
      var existing = q('[data-mobile-wizard-nav]');
      if(existing) return existing;
      var nav = document.createElement('div');
      nav.className = 'scb-mobile-wizard-nav';
      nav.setAttribute('data-mobile-wizard-nav', '');
      nav.innerHTML = '<button type="button" data-mobile-prev>Back</button><div class="scb-mobile-wizard-nav-center"><span data-mobile-count>Step 1 of 9</span><strong data-mobile-title>Style</strong></div><button type="button" data-mobile-next>Next</button>';
      root.appendChild(nav);
      return nav;
    }

    var nav = createNav();
    var prevBtn = nav.querySelector('[data-mobile-prev]');
    var nextBtn = nav.querySelector('[data-mobile-next]');
    var countEl = nav.querySelector('[data-mobile-count]');
    var titleEl = nav.querySelector('[data-mobile-title]');

    function stepById(id){
      for(var i = 0; i < steps.length; i++){
        if(steps[i].id === id) return steps[i];
      }
      return steps[0];
    }

    function stepOrderIndex(id){
      for(var i = 0; i < steps.length; i++){
        if(steps[i].id === id) return i;
      }
      return 0;
    }

    function optionSection(id){
      return q('[data-step-section="'+id+'"]');
    }

    function isStepAvailable(step){
      if(step.id === 'style' || step.id === 'size' || step.id === 'fabric' || step.id === 'cart') return true;
      var section = optionSection(step.id);
      if(!section) return false;
      if(step.id === 'bow' && root.classList.contains('scb-no-bow-option')) return false;
      if(section.style && section.style.display === 'none') return false;
      return true;
    }

    function availableSteps(){
      return steps.filter(isStepAvailable);
    }

    function elementsForStep(id){
      if(id === 'style') return qa('[data-style-drawer]');
      if(id === 'size') return qa('[data-size-section]');
      if(id === 'fabric') return qa('.scb-fabric-head, .scb-swatch-grid, .scb-fabric-done');
      if(id === 'cart') return qa('.scb-customizer-grid > .scb-panel:last-child');
      var section = optionSection(id);
      return section ? [section] : [];
    }

    function allScreenElements(){
      return qa('[data-style-drawer], [data-size-section], .scb-fabric-head, .scb-swatch-grid, .scb-fabric-done, [data-step-section], .scb-customizer-grid > .scb-panel:last-child');
    }

    function collapseOptionSectionsExcept(id){
      qa('[data-step-section]').forEach(function(section){
        section.classList.toggle('is-collapsed', section.getAttribute('data-step-section') !== id);
      });
    }

    function openStyleScreen(){
      var drawer = q('[data-style-drawer]');
      if(drawer) drawer.setAttribute('open', 'open');
      var title = q('[data-style-title]');
      if(title) title.textContent = 'Select Style';
      collapseOptionSectionsExcept('');
    }

    function openSizeScreen(){
      var section = q('[data-size-section]');
      if(section){
        section.classList.remove('scb-size-collapsed');
        var btn = section.querySelector('[data-reopen-size]');
        if(btn) btn.remove();
      }
      var title = q('[data-size-title]');
      var summary = q('[data-size-summary]');
      if(title) title.textContent = 'Choose size';
      if(summary) summary.hidden = true;
      collapseOptionSectionsExcept('');
    }

    function openFabricScreen(){
      root.classList.remove('scb-fabric-collapsed');
      var head = q('.scb-fabric-head');
      var h2 = head ? head.querySelector('h2') : null;
      var reopen = head ? head.querySelector('[data-reopen-fabrics]') : null;
      var grid = q('.scb-swatch-grid');
      var done = q('.scb-fabric-done');
      if(h2) h2.textContent = 'Choose Fabrics';
      if(reopen) reopen.remove();
      if(grid) grid.style.display = '';
      if(done) done.style.display = '';
      collapseOptionSectionsExcept('');
    }

    function openOptionScreen(id){
      collapseOptionSectionsExcept(id);
      var section = optionSection(id);
      if(section) section.classList.remove('is-collapsed');
    }

    function prepareStep(id){
      if(id === 'style') openStyleScreen();
      else if(id === 'size') openSizeScreen();
      else if(id === 'fabric') openFabricScreen();
      else if(id === 'cart') collapseOptionSectionsExcept('');
      else openOptionScreen(id);
    }

    function scrollToActive(){
      if(!isMobile()) return;
      var target = elementsForStep(current)[0];
      if(!target) return;
      var sticky = q('.scb-stage-card');
      var offset = sticky ? sticky.getBoundingClientRect().height + 12 : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({top: Math.max(0, top), behavior:'smooth'});
    }

    function normalizeCurrent(list){
      var found = list.some(function(step){ return step.id === current; });
      if(found) return;
      var wanted = stepOrderIndex(current);
      current = (list.filter(function(step){ return stepOrderIndex(step.id) >= wanted; })[0] || list[list.length - 1] || steps[0]).id;
    }

    function render(options){
      root.classList.add('scb-mobile-wizard');
      if(!isMobile()){
        nav.setAttribute('aria-hidden', 'true');
        return;
      }

      nav.removeAttribute('aria-hidden');
      var list = availableSteps();
      if(!list.length) return;
      normalizeCurrent(list);

      var index = list.map(function(step){ return step.id; }).indexOf(current);
      var step = stepById(current);
      root.setAttribute('data-mobile-step', current);
      prepareStep(current);

      allScreenElements().forEach(function(el){ el.classList.remove('scb-mobile-wizard-active'); });
      elementsForStep(current).forEach(function(el){ el.classList.add('scb-mobile-wizard-active'); });

      if(countEl) countEl.textContent = 'Step ' + (index + 1) + ' of ' + list.length;
      if(titleEl) titleEl.textContent = step.title;
      if(prevBtn) prevBtn.disabled = index <= 0;
      if(nextBtn) nextBtn.disabled = index >= list.length - 1;

      if(!options || options.scroll !== false){
        window.requestAnimationFrame(function(){ scrollToActive(); });
      }
    }

    function go(delta){
      if(!isMobile()) return;
      var list = availableSteps();
      if(!list.length) return;
      normalizeCurrent(list);
      var ids = list.map(function(step){ return step.id; });
      var index = ids.indexOf(current);
      var nextIndex = Math.max(0, Math.min(list.length - 1, index + delta));
      if(nextIndex === index) return;
      root.setAttribute('data-mobile-dir', delta < 0 ? 'back' : 'next');
      current = list[nextIndex].id;
      render();
    }

    function scheduleRender(delay){
      window.clearTimeout(renderTimer);
      renderTimer = window.setTimeout(function(){ render({scroll:false}); }, delay || 80);
    }

    function queueRender(delay){
      window.setTimeout(function(){ render({scroll:false}); }, delay || 0);
    }

    if(prevBtn){
      prevBtn.addEventListener('click', function(event){
        event.preventDefault();
        go(-1);
      });
    }

    if(nextBtn){
      nextBtn.addEventListener('click', function(event){
        event.preventDefault();
        go(1);
      });
    }

    root.addEventListener('click', function(event){
      var target = event.target && event.target.closest ? event.target.closest('.scb-style-card, .scb-mode-btn, [data-color-kind], [data-choice-kind], [data-toggle-step], [data-reopen-fabrics], [data-complete-step]') : null;
      if(!target || !root.contains(target)) return;
      [0, 90, 240, 520].forEach(queueRender);
      if(isMobile() && target.hasAttribute('data-complete-step')){
        window.setTimeout(function(){ go(1); }, 120);
      }
    }, true);

    ['click','pointerdown','dragenter','dragover','drop'].forEach(function(type){
      root.addEventListener(type, function(event){
        if(!isMobile() || current === 'fabric') return;
        var zone = event.target && event.target.closest ? event.target.closest('.scb-zone-group') : null;
        if(!zone || !root.contains(zone)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    });

    if(window.MutationObserver){
      var observer = new MutationObserver(function(){ scheduleRender(80); });
      qa('[data-step-section]').forEach(function(section){
        observer.observe(section, {attributes:true, attributeFilter:['style']});
      });
    }

    if(mq && mq.addEventListener) mq.addEventListener('change', function(){ render({scroll:false}); });
    else if(mq && mq.addListener) mq.addListener(function(){ render({scroll:false}); });
    window.addEventListener('resize', function(){ scheduleRender(120); });

    render({scroll:false});
    [300, 900, 1800].forEach(function(ms){ window.setTimeout(function(){ render({scroll:false}); }, ms); });
  }

  function initAllMobileWizard(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initMobileWizard);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllMobileWizard);
  else initAllMobileWizard();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initMobileWizard(root);
  });
})();

/* Final label/color sync for the current fabric, bow, lace, and sequin options. */
(function(){
  function initLabelColorSync(root){
    if(!root || root.dataset.scbLabelColorSync === 'true') return;
    root.dataset.scbLabelColorSync = 'true';

    var fabricNames = {
      'pink-star': 'Blush Pointelle',
      'solid-black': 'Solid Black',
      'polka-dot': 'Polka Dot',
      'baby-pink-paisley': 'Baby Pink Paisley',
      'cocoa-vine': 'Cocoa Vine',
      'teal-daisy': 'Teal Daisy',
      'charcoal-border': 'Charcoal Border',
      'slate-bloom': 'Slate Bloom',
      'midnight-floral': 'Midnight Floral',
      'rosy-lotus': 'Rosy Lotus'
    };
    var colors = {
      bow: {'None':'transparent','Dusty Rose':'#B78792','Charcoal':'#111111','Mocha':'#7B6A58','Moss':'#61735A','Baby Blue':'#A9C9DF'},
      lace: {'Black':'#111111','Baby Pink':'#DABEBC','Brown':'#5E4736'},
      sequins: {'Rose Gold':'#F7B7A3','Chrome Black':'#3C3F44'}
    };

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function active(kind){
      return q('[data-color-kind="'+kind+'"].is-active');
    }
    function activeName(kind, fallback){
      var btn = active(kind);
      return btn ? (btn.getAttribute('data-color-name') || fallback) : fallback;
    }
    function outlineFor(hex){
      if(!hex) return '#ffffff';
      var h = hex.replace('#','');
      if(h.length !== 6) return '#ffffff';
      var r = parseInt(h.slice(0,2), 16);
      var g = parseInt(h.slice(2,4), 16);
      var b = parseInt(h.slice(4,6), 16);
      return ((0.2126 * r + 0.7152 * g + 0.0722 * b) / 255) > 0.58 ? '#111111' : '#ffffff';
    }

    function normalizeLabels(){
      qa('.scb-swatch').forEach(function(btn){
        var id = btn.getAttribute('data-swatch-id') || '';
        var name = fabricNames[id];
        if(!name) return;
        btn.setAttribute('data-swatch-name', name);
        var label = btn.querySelector('span');
        var img = btn.querySelector('img');
        if(label) label.textContent = name;
        if(img) img.alt = name + ' swatch';
      });

      qa('[data-color-kind="bow"]').forEach(function(btn){
        if((btn.getAttribute('data-color-name') || '') === 'Coal'){
          btn.setAttribute('data-color-name', 'Charcoal');
          btn.childNodes.forEach(function(node){
            if(node.nodeType === 3) node.textContent = 'Charcoal';
          });
        }
      });

      qa('[data-color-kind="sequins"]').forEach(function(btn){
        if((btn.getAttribute('data-color-name') || '') === 'Chrome Grey'){
          btn.setAttribute('data-color-name', 'Chrome Black');
          btn.setAttribute('data-color-value', '#3C3F44');
          var dot = btn.querySelector('span');
          if(dot) dot.style.background = '#3C3F44';
          btn.childNodes.forEach(function(node){
            if(node.nodeType === 3) node.textContent = 'Chrome Black';
          });
        }
      });
    }

    function sync(){
      normalizeLabels();

      var swatch = q('.scb-swatch.is-active');
      var swatchLabel = q('[data-active-swatch-label]');
      if(swatch && swatchLabel) swatchLabel.textContent = swatch.getAttribute('data-swatch-name') || swatchLabel.textContent;

      var bowName = activeName('bow', root.classList.contains('scb-bow-required') ? 'Charcoal' : 'None');
      if(root.classList.contains('scb-bow-required') && (!bowName || bowName === 'None')) bowName = 'Charcoal';
      var bowHex = colors.bow[bowName] || (bowName === 'None' ? 'transparent' : '#111111');
      var bowSummary = q('[data-bow-summary]');
      var bowInput = q('[data-input-bow-color]');
      if(bowSummary) bowSummary.textContent = bowName;
      if(bowInput) bowInput.value = bowName;
      root.style.setProperty('--scb-bow-color', bowHex);
      root.style.setProperty('--scb-bow-layer-color', bowHex);
      root.style.setProperty('--scb-bow-ui-color', bowHex);

      var laceName = activeName('lace', 'Black');
      var laceHex = colors.lace[laceName] || '#111111';
      var laceSummary = q('[data-lace-summary]');
      var laceInput = q('[data-input-lace-color]');
      if(laceSummary) laceSummary.textContent = laceName;
      if(laceInput) laceInput.value = laceName;
      root.style.setProperty('--scb-lace-layer-color', laceHex);

      var seqName = activeName('sequins', 'Rose Gold');
      var seqHex = colors.sequins[seqName] || '#F7B7A3';
      root.style.setProperty('--scb-sequin-layer-color', seqHex);
      root.style.setProperty('--scb-sequin-outline-color', outlineFor(seqHex));
      var seqYes = q('[data-choice-kind="sequins"].is-active');
      var seqSummary = q('[data-sequin-summary]');
      var seqInput = q('[data-input-sequin-color]');
      if(seqInput) seqInput.value = seqName;
      if(seqSummary && seqYes && seqYes.getAttribute('data-choice-value') === 'Yes'){
        seqSummary.textContent = 'Yes · ' + seqName;
      }
    }

    root.addEventListener('click', function(event){
      var trigger = event.target && event.target.closest ? event.target.closest('.scb-swatch, [data-color-kind], [data-choice-kind]') : null;
      if(!trigger || !root.contains(trigger)) return;
      [0, 60, 180, 420].forEach(function(delay){ setTimeout(sync, delay); });
    }, true);

    sync();
    [250, 900, 1800].forEach(function(delay){ setTimeout(sync, delay); });
  }

  function initAllLabelColorSync(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initLabelColorSync);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllLabelColorSync);
  else initAllLabelColorSync();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initLabelColorSync(root);
  });
})();

/* v32: custom preview bottoms stay full-size alone and 15% smaller when paired with a top. */
(function(){
  function initV32(root){
    if(!root || root.dataset.scbV32Initialized === 'true') return;
    root.dataset.scbV32Initialized = 'true';

    function q(sel){ return root.querySelector(sel); }

    var customBottoms = {
      bottom_side_tie_shorts: {
        setTransform: 'translate(calc(-3.5% + 0.5cm), 0.5cm) scale(0.795)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% - 0.5in)) scale(0.95)'
      },
      bottom_hipster: {
        setTransform: 'translateX(calc(-3.5% + 0.5cm)) scale(0.867)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% - 1in)) scale(0.95)'
      },
      bottom_2_layer_hipster: {
        setTransform: 'translateX(calc(-3.5% + 0.5cm)) scale(0.867)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% - 1in)) scale(0.95)'
      },
      bottom_cheeky: {
        setTransform: 'translate(calc(-3.5% + 0.5cm), -0.5cm) scale(0.816)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% - 0.5in)) scale(0.95)'
      },
      bottom_2_layer_cheeky: {
        setTransform: 'translate(calc(-3.5% + 0.5cm), -0.5cm) scale(0.816)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% - 0.5in)) scale(0.95)'
      }
    };

    var mobileCustomBottoms = {
      bottom_side_tie_shorts: {
        setTransform: 'translate(calc(-3.5% + 0.35cm), 0.5cm) scale(0.735)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% + 0.5in)) scale(0.888)'
      },
      bottom_hipster: {
        setTransform: 'translateX(calc(-3.5% + 0.35cm)) scale(0.802)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% + 0.5in)) scale(0.888)'
      },
      bottom_2_layer_hipster: {
        setTransform: 'translateX(calc(-3.5% + 0.35cm)) scale(0.802)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% + 0.5in)) scale(0.888)'
      },
      bottom_cheeky: {
        setTransform: 'translate(calc(-3.5% + 0.35cm), calc(-0.5cm + 0.25in)) scale(0.755)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% + 0.5in)) scale(0.888)'
      },
      bottom_2_layer_cheeky: {
        setTransform: 'translate(calc(-3.5% + 0.35cm), calc(-0.5cm + 0.25in)) scale(0.755)',
        bottomTransform: 'translate(calc(-5.5% + 0.5cm), calc(-18% + 0.5in)) scale(0.888)'
      }
    };

    var bottomOnlyScaledBottoms = {
      bottom_1_layer: true,
      bottom_2_layer: true,
      bottom_4_layer: true
    };

    function isMobilePreview(){
      var rootWidth = root.getBoundingClientRect ? root.getBoundingClientRect().width : 0;
      return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) || (rootWidth > 0 && rootWidth <= 820);
    }

    function resetSvg(svg){
      svg.style.removeProperty('transform');
      svg.style.removeProperty('transform-origin');
      svg.style.removeProperty('margin-top');
      svg.style.removeProperty('margin-bottom');
    }

    function formatPatternNumber(value){
      return String(Math.round(value * 1000) / 1000);
    }

    function setShortsSetPatternScale(activeId, mode){
      var svg = q('.scb-template-svg[data-style-kind="bottom"][data-style-id="bottom_side_tie_shorts"]');
      if(!svg) return;
      var scale = (activeId === 'bottom_side_tie_shorts' && mode === 'set') ? 0.68 : 1;
      Array.prototype.slice.call(svg.querySelectorAll('pattern[id^="scb-pattern-bottom_side_tie_shorts-"]')).forEach(function(pattern){
        if(!pattern.dataset.scbOriginalWidth){
          pattern.dataset.scbOriginalWidth = pattern.getAttribute('width') || '0';
          pattern.dataset.scbOriginalHeight = pattern.getAttribute('height') || '0';
        }
        var originalWidth = parseFloat(pattern.dataset.scbOriginalWidth || '0');
        var originalHeight = parseFloat(pattern.dataset.scbOriginalHeight || '0');
        if(!originalWidth || !originalHeight) return;
        var width = originalWidth * scale;
        var height = originalHeight * scale;
        pattern.setAttribute('width', formatPatternNumber(width));
        pattern.setAttribute('height', formatPatternNumber(height));
        var image = pattern.querySelector('image');
        if(image){
          image.setAttribute('width', formatPatternNumber(width + 1));
          image.setAttribute('height', formatPatternNumber(height + 1));
        }
      });
    }

    function applyCustomBottomSizing(){
      var activeBottom = q('.scb-style-card[data-style-kind="bottom"].is-active');
      var activeMode = q('.scb-mode-btn.is-active');
      var activeId = activeBottom ? activeBottom.getAttribute('data-style-id') : '';
      var mode = activeMode ? activeMode.getAttribute('data-mode') : 'set';
      setShortsSetPatternScale(activeId, mode);

      Object.keys(customBottoms).forEach(function(styleId){
        var svg = q('.scb-template-svg[data-style-kind="bottom"][data-style-id="'+styleId+'"]');
        var config = isMobilePreview() && mobileCustomBottoms[styleId] ? mobileCustomBottoms[styleId] : customBottoms[styleId];
        if(!svg) return;
        resetSvg(svg);
        if(activeId !== styleId) return;
        if(mode === 'set'){
          svg.style.setProperty('transform', config.setTransform, 'important');
          svg.style.setProperty('transform-origin', 'center top', 'important');
          svg.style.setProperty('margin-bottom', '-22px', 'important');
        } else if(mode === 'bottom'){
          svg.style.setProperty('transform', config.bottomTransform, 'important');
          svg.style.setProperty('transform-origin', 'center center', 'important');
          svg.style.setProperty('margin-top', '-18px', 'important');
        }
      });
      Object.keys(bottomOnlyScaledBottoms).forEach(function(styleId){
        var svg = q('.scb-template-svg[data-style-kind="bottom"][data-style-id="'+styleId+'"]');
        if(!svg) return;
        resetSvg(svg);
        if(activeId === styleId && mode === 'bottom'){
          svg.style.setProperty('transform', 'scale(0.9)', 'important');
          svg.style.setProperty('transform-origin', 'center center', 'important');
        }
      });
      if(typeof root.scbSyncOptionalOverlayPositions === 'function'){
        root.scbSyncOptionalOverlayPositions();
      }
    }

    root.querySelectorAll('.scb-style-card, .scb-mode-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(applyCustomBottomSizing, 0);
        setTimeout(applyCustomBottomSizing, 80);
      });
    });

    window.addEventListener('resize', function(){
      setTimeout(applyCustomBottomSizing, 120);
    });

    [0, 120, 450, 900].forEach(function(delay){
      setTimeout(applyCustomBottomSizing, delay);
    });
  }

  function initAllV32(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV32);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV32);
  else initAllV32();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV32(root);
  });
})();

/* Keep preview-only bottom style cards visible in the bottom-style grid. */
(function(){
  function initV33(root){
    if(!root || root.dataset.scbV33Initialized === 'true') return;
    root.dataset.scbV33Initialized = 'true';

    function revealPreviewOnlyCards(){
      ['bottom_side_tie_shorts', 'bottom_hipster', 'bottom_2_layer_hipster', 'bottom_cheeky', 'bottom_2_layer_cheeky'].forEach(function(styleId){
        var card = root.querySelector('.scb-style-card[data-style-kind="bottom"][data-style-id="'+styleId+'"]');
        if(!card) return;
        card.hidden = false;
        card.removeAttribute('hidden');
        card.style.removeProperty('display');
        card.style.removeProperty('visibility');
        card.style.removeProperty('opacity');
      });
    }

    root.addEventListener('click', function(event){
      var trigger = event.target && event.target.closest ? event.target.closest('.scb-mode-btn, .scb-style-card, [data-style-drawer] summary') : null;
      if(!trigger || !root.contains(trigger)) return;
      [0, 80, 220, 480].forEach(function(delay){
        setTimeout(revealPreviewOnlyCards, delay);
      });
    }, true);

    revealPreviewOnlyCards();
    [180, 600, 1200].forEach(function(delay){
      setTimeout(revealPreviewOnlyCards, delay);
    });
  }

  function initAllV33(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV33);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV33);
  else initAllV33();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV33(root);
  });
})();

/* v44: custom bottom lace/bow rules for set mode vs standalone bottom mode. */
(function(){
  function initV44(root){
    if(!root || root.dataset.scbV44Initialized === 'true') return;
    root.dataset.scbV44Initialized = 'true';

    var customBottoms = {
      bottom_side_tie_shorts: true,
      bottom_hipster: true,
      bottom_2_layer_hipster: true,
      bottom_cheeky: true,
      bottom_2_layer_cheeky: true
    };
    var userPickedCustomBow = false;
    var userPickedCustomLace = false;

    function q(sel){ return root.querySelector(sel); }
    function qa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function activeStyle(kind){
      var btn = q('.scb-style-card[data-style-kind="'+kind+'"].is-active');
      return btn ? (btn.getAttribute('data-style-id') || '') : '';
    }
    function activeMode(){
      var btn = q('.scb-mode-btn.is-active');
      return btn ? (btn.getAttribute('data-mode') || 'set') : 'set';
    }
    function activeColor(kind){
      var btn = q('[data-color-kind="'+kind+'"].is-active');
      return btn ? (btn.getAttribute('data-color-name') || '') : '';
    }
    function bottomOverlay(){
      var bottomId = activeStyle('bottom');
      if(!customBottoms[bottomId]) return null;
      return q('.scb-optional-svg[data-style-kind="bottom"][data-style-id="'+bottomId+'"]');
    }
    function syncCustomBottomOptions(){
      var mode = activeMode();
      var topId = activeStyle('top');
      var bottomId = activeStyle('bottom');
      var overlay = bottomOverlay();
      if(!overlay) return;

      var setMode = mode === 'set';
      var showLace = setMode ? (topId === 'top_2_layer' || topId === 'top_4_layer') : userPickedCustomLace;
      var bowName = activeColor('bow');
      var bowSelected = !!bowName && bowName !== 'None';
      var bowRequired = setMode && (topId === 'top_4_layer' || bottomId === 'bottom_4_layer');
      var showBow = bowRequired || bowSelected;

      overlay.classList.toggle('scb-show-lace', !!showLace);
      overlay.classList.toggle('scb-show-bow', !!showBow);

      root.classList.toggle('scb-custom-bottom-active', !!customBottoms[bottomId]);
      root.classList.toggle('scb-custom-bottom-auto-lace', !!showLace);
      root.classList.toggle('scb-custom-bottom-auto-bow', !!showBow);
    }

    root.addEventListener('click', function(event){
      var colorBtn = event.target && event.target.closest ? event.target.closest('[data-color-kind]') : null;
      if(colorBtn && root.contains(colorBtn)){
        var kind = colorBtn.getAttribute('data-color-kind');
        if(kind === 'bow') userPickedCustomBow = (colorBtn.getAttribute('data-color-name') || '') !== 'None';
        if(kind === 'lace') userPickedCustomLace = true;
      }
      [0, 80, 220, 500].forEach(function(delay){
        setTimeout(syncCustomBottomOptions, delay);
      });
    }, true);

    if(window.MutationObserver){
      var observer = new MutationObserver(function(){
        setTimeout(syncCustomBottomOptions, 0);
      });
      observer.observe(root, {childList: true, subtree: true});
    }

    [0, 160, 420, 900, 1500].forEach(function(delay){
      setTimeout(syncCustomBottomOptions, delay);
    });
  }

  function initAllV44(){
    document.querySelectorAll('[data-scb-customizer]').forEach(initV44);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllV44);
  else initAllV44();

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-scb-customizer]') : null;
    if(root) initV44(root);
  });
})();
